import React, {Component} from "react";
import CourseStatusContainer from "../../../containers/Dashboard/DashboardUser/CourseStatusContainer";
import PropTypes from 'prop-types';
import trophy from '../../../assets/img/trophy-cup.svg';
import ConfirmationModal from './ConfirmationModal';
import {NotificationManager} from 'react-notifications';
import moment from 'moment';
import ReactHighcharts from 'react-highcharts';
import PieChart from 'react-minimal-pie-chart';
import userImage from '../../../assets/img/128x128.jpg';
import api from '../../../utils/api';
import jwt from 'jsonwebtoken';
import loadingIcon from '../../../assets/img/loading-icon.svg';
import {steps} from './tour.js';
import { Steps} from 'intro.js-react';
import {Link} from 'react-router-dom';
import 'intro.js/introjs.css';
import AvatarModalContainer from '../../../containers/Dashboard/DashboardUser/AvatarModalContainer';
import DeadlineModal from './DeadlineModal';
import Counter from './Counter';

/* global $ */

const subjectColors = ["#ada7fc", "#ed6e86", "#ffde74"];

class Dashboard extends Component {

    constructor(props){
        super(props);

        this.state = {
            stepsEnabled: null,
            initialStep: 0,
            steps: steps,
            hintsEnabled: true,
      hints: [
       
      ],
            settingSubjectName: '',
            settingSubjectId: '',
            confirmTestDateModal: false,
            testDateConfirmed: '',
            testDate: '',
            confirmSubjectDateModal: false,
            subjectDate: '',
            subjectDateConfirmed: '',
            view: 'attendance',
            viewLoaded: false,
            currentSubject: null,
            attendanceType: 'calendar',
            chart: [],
            chartX: [],
            chartType: 'bar',
            completionPercent: null,
            attentivePercent: null,
            attendanceHours: [{data: [], name: 'Attendance'}],
            improvement: {
                attendance: null,
                attentiveness: null,
                efficiency: null,
                quiz: null
            },
            studiedLastMonth: null,
            studiedTotal: null,
            studiedAverage: null,
            canResetTestDate: false,
            timeTaken: -1,
            requiredPerDay: -1,
            timeLeft: -1,
            timerId: null,
            estimatedTime: -1,
            estimatedTimeClass: '',
            subjectMonth: new Date().getMonth(),
            timeToTest: -1
        }
    }

    setView = (view, loaded) => {
        if(this.state.view !== view){
            this.setState({view, viewLoaded: loaded});
        }
    }

    renderTabNew = () => {
        return (
            this.props.allCourseUsers.map((item, index) => {

                if(item) {
                    if(item.Course){
                        return (
                            <li
                                key={index}
                                className={window.location.href.indexOf(item.Course.id) > -1 ? 'active' : ''}
                            >
                                <Link
                                    to={`/dashboard/${item.Course.id}`}
                                >
                                    {item.Course.name || ''}
                                    
                                </Link>
                            </li>
                        )
                    }else {
                        return null;
                    }
                }else{
                    return null
                }
            })
        )
    };

    renderAttendance = (props, state) => {
        
        this.setState({viewLoaded: true}, () => {
            let data = [];
            if(props.courseUser[0]){
                if(props.courseUser[0].studied){
                    props.courseUser[0].studied.map(a => {
                        let d = moment(a.date).format('YYYY-MM-DD');
                        let existingDate = data.filter(da => da.date === d);
                        
                        
                        if(existingDate.length > 0){
                            existingDate[0].userTime += a.time;
                            
                            let hours = moment.duration(existingDate[0].userTime*1000).get('hours');
                            let minutes = moment.duration(existingDate[0].userTime*1000).get('minutes');
                            if(hours > 0){
                                existingDate[0].title = "I studied for<br /><br /><span className='text-green'>" +  hours + " hours and " + minutes + " minutes</span>";  
                            }else{
                                existingDate[0].classname = 'bg-yellow'; 
                                existingDate[0].title = "I only studied for<br /><br /><span className='text-yellow'>" + minutes + " minutes</span>";  
                            }
                            
                        }else{
                            let hours = moment.duration(a.time*1000).get('hours');
                            let minutes = moment.duration(a.time*1000).get('minutes');
                            let title = "I studied for<br /><br /><span className='text-green'>" +  hours + "hours and " + minutes + " minutes</span>";
                            let className = 'bg-green';
                             if(hours <= 0){
                                className = 'bg-yellow'; 
                                title = "I only studied for<br /><br /><span className='text-yellow'>" + minutes + " minutes</span>";  
                            }
                            data.push({
                                date: moment(a.date).format('YYYY-MM-DD'), 
                                classname: className, 
                                userTime: a.time, 
                                title: title
                            });
                        }
                        return true;
                    })
                }
            }
            
            let today = moment();
            let started = moment(props.courseUser[0].created);
            let current = started;
            
            while(today.diff(current) > 0){
                let formatted = current.format('YYYY-MM-DD');
                let existingDate = data.filter(d => d.date === formatted);
                if(existingDate.length === 0){
                    data.push({
                        date: current.format('YYYY-MM-DD'), 
                        classname: 'bg-orange', 
                        timeSpent: 0, 
                        title:"<span className='text-danger'>I didn't study</span>"
                        
                    });
                }
                current.add(1, 'days');
            }
            
            //{"date":"2018-07-12","badge":false,"title":"I studied for<br /><br /><span className='text-success'>1 hour 23 minutes and 23 seconds</span>","classname":"bg-success"},
            //{"date":"2018-07-13","badge":false,"title":"<span className='text-danger'>I wasn't online</span>","classname":"bg-orange"},
            $('.calendar_1').html('<div id="test_calendar"></div>');
            $("#test_calendar").empty();
            $("#test_calendar").zabuto_calendar({
                cell_border: false,
                /*legend: [
                    {type: "block", label: "Deadline Days", classname: "bg-grey"},
                    {type: "block", label: "Expected Deadline", classname: "bg-orange"},
                    {type: "block", label: "Exam Day", classname: "bg-purple"},
                    {type: "block", label: "Graduation", classname: "bg-success"},
                ],*/
                action: function () {
                    //NotificationManager.error("You've already set a test date.");
                },
                action_nav: function(e) { 
                    if(this.id.indexOf('next') > -1){
                        // move next
                        setTimeout(function(){
                            $(document).find(".event-styled").popover({
                            trigger:'hover',
                            container:'body',
                            html:true
                          });
                        }, 500);
                       
                        
                    }else if(this.id.indexOf('prev') > -1){
                        // prev
                        setTimeout(function(){
                            $(document).find(".event-styled").popover({
                            trigger:'hover',
                            container:'body',
                            html:true
                          });
                        }, 500);
                       
                    }
                    
                },
                data: data
            });
            
           $(document).find(".event-styled").popover({
                trigger:'hover',
                container:'body',
                html:true
              });
        });
    }

    renderConfigHighchart = (statisticDiagram) => {
        let yName = this.state.view.toUpperCase();
        let self = this;
        let {chartType, chartX} = this.state;

        if(chartType === 'line'){
            if(this.state.view === 'quiz'){

            }else {


                return (
                    {
                        chart: {
                            zoomType: 'line',
                            height: 290,
                            backgroundColor: {
                                linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                                stops: [
                                    [0, '#3c3840'],
                                    [1, '#3C3840']
                                ]
                            }
                        },
                        colors: ['#e84a5f','#fff'],
                        title: false,
                        subtitle: false,
                        xAxis: [{
                            categories: chartX,
                            crosshair: true,
                            labels: {
                                style: {
                                    color: '#fff'
                                }
                            },
                            style: {
                                color: '#fff'
                            }
                        }],
                        yAxis: [{ // Primary yAxis
                            labels: {
                                format: '{value}%',
                                style: {
                                    color: '#fff'
                                }
                            },
                            title: {
                                text: 'Video Question Accuracy (percentage)',
                                style: {
                                    color: '#fff'
                                },
                            },
                            min: 0,
                            max: 120,
                            gridLineColor: '#565058'

                        }],
                        tooltip: {
                            shared: true
                        },
                        legend: false,
                        series: statisticDiagram
                    }

                )
            }
        }else if(chartType === 'bar') {
            if(this.state.view === 'quiz'){
                return (
                    {
                        chart: {
                            height: 290,
                            zoomType: 'xy',
                            backgroundColor: {
                                linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                                stops: [
                                    [0, '#3C3840'],
                                    [1, '#3C3840']
                                ]
                            }
                        },
                        colors: ['#e84a5f','#fff'],
                        title: false,
                        subtitle: false,
                        xAxis: [{
                            categories: this.state.chartX,
                            crosshair: true
                        }],
                        yAxis: [{ // Secondary yAxis
                            gridLineColor: '#565058',
                            min: 0,
                            max: 100,
                            title: {
                                text: 'Quiz Percentage',
                                style: {
                                    color: '#fff'
                                }
                            },
                            labels: {
                                format: '{value}%',
                                style: {
                                    color: '#fff'
                                }
                            }

                        }, { // Primary yAxis
                            labels: {
                                format: '{value}x',
                                style: {
                                    color: '#fff'
                                }
                            },
                            title: {
                                text: 'Time Spent On Lecture',
                                style: {
                                    color: '#b15b00'
                                }
                            },
                            
                            opposite: true,
                            gridLineColor: '#565058'

                        }],
                        tooltip: {
                            shared: true
                        },
                        legend: false,
                        series: statisticDiagram
                    }
                )
            }else if(this.state.view === 'efficiency'){
                return ({
                    chart: {
                        zoomType: 'line',
                        height: 290,
                        backgroundColor: {
                            linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                            stops: [
                                [0, '#3c3840'],
                                [1, '#3C3840']
                            ]
                        }
                    },
                    title: false,
                    subtitle: false,
                    
                    colors: ['#e84a5f','#fff'],
                    xAxis: [
                        {
                            categories: this.state.chartX,
                            crosshair: true,
                            labels: {
                                style: {
                                    color: '#fff'
                                }
                            },

                            title: {
                                text: 'Chapter | Part',
                                style: {
                                    color: '#fff'
                                },
                            },
                           
                            gridLineColor: '#555'
                        }
                        

                    ],
                    yAxis: [{ // Primary yAxis
                        labels: {
                            min: 0,
                            format: '{value}',
                            style: {
                                color: '#fff'
                            }
                        },
                        title: {
                            text: 'Efficiency Percentage',
                            style: {
                                color: '#fff'
                            },
                        },
                        min: 0,
                        max: 300,
                        gridLineColor: '#555'
                    }, { // Secondary yAxis
                        title: false,
                        labels: false,
                        opposite: true,
                        gridLineColor: '#555'

                    }],
                    tooltip: {
                        shared: true
                    },

                    legend: {
                        layout: 'horizontal',
                        align: 'left',
                        x: 0,
                        verticalAlign: 'top',
                        y: '100',
                        floating: true
                    },
                    plotOptions: {
                        series: {
                            borderColor: '#e84a5f'
                        }
                    },
                    series: statisticDiagram
                })
            }else if(this.state.view === 'attendance' && this.state.attendanceType === 'graph'){
                return (
                    {
                        chart: {
                            type: 'column',
                            height: 290,
                            backgroundColor: {
                                linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                                stops: [
                                    [0, '#3c3840'],
                                    [1, '#3C3840']
                                ]
                            }
                        },
                        colors: ['#fff'],
                        subtitle: false,
                        title: false,
                        xAxis: {
                            type: 'category',
                            categories: this.state.chartX,
                            labels: {
                                style: {
                                    color: '#fff'
                                }
                            }
                        },
                        yAxis: {
                            title: {
                                text: 'No. of Hours Spent',
                                style: {
                                    color: '#fff'
                                }
                            },
                            labels: {
                                style: {
                                    color: '#fff'
                                }
                            },
                            gridLineColor: '#555',

                        },
                        legend: {
                            enabled: false
                        },
                        plotOptions: {
                            series: {
                                borderWidth: 0,
                                dataLabels: {
                                    enabled: true,
                                    format: '{point.y:.1f}'
                                },
                                style: {
                                    color: '#fff'
                                }

                            }
                        },

                        tooltip: {
                            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}</b> of total<br/>'
                        },

                        series: statisticDiagram
                    }
                )
            }
            if(this.state.view === 'completion'){
                return (
                    {
                        chart: {
                            type: 'column',
                            height: 290,
                            backgroundColor: {
                                linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                                stops: [
                                    [0, '#3c3840'],
                                    [1, '#3C3840']
                                ]
                            }
                        },
                        legend:false,
                        colors: subjectColors,
                        //colors: ['#8CBF3B', '#333', '#77AA29', '#333', '#FFFC58', '#333', '#EE5389', '#333', '#FE476F', '#333'],
                        //colors: ['#36E33A', '#333', '#00A600', '#333', '#3A7F28', '#333', '#2D631E', '#333', '#224A16', '#333'],
                        //colors: ['#224A16', '#333', '#2D631E', '#333', '#3A7F28', '#333', '#00A600', '#333', '#36E33A', '#333'],
                        //colors: ['#36E33A', '#333', '#00A600', '#333', '#3A7F28', '#333', '#6F7524', '#333', '#986D21', '#333'],
                        //colors: ['#3CF53E', '#333', '#00CF00', '#333', '#53B538', '#333', '#C9A833', '#333', '#C56D21', '#333'],

                        title: false,
                        xAxis: {
                            categories: chartX,
                            labels: {
                                style: {
                                    color: '#fff'
                                }
                            }
                        },
                        yAxis: {
                            min: 0,
                            max: 100,
                            title: {
                                text: 'Subject Completion',
                                style: {
                                    color: '#fff'
                                }
                            },
                            labels: {
                                style: {
                                    color: '#fff'
                                }
                            },
                            gridLineColor: "#555"

                        },
                        tooltip: {
                            pointFormat: '<span style="">{series.name}</span>: <b>{point.y}%</b><br/>',
                            shared: true
                        },
                        plotOptions: {

                            series: {
                                borderColor: 'transparent'
                            }
                        },
                        series: statisticDiagram
                    }
                )
            }else {
                return (
                    {
                        chart: {
                            height: 300,
                            type: 'column',
                            backgroundColor: {
                                linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                                stops: [
                                    [0, '#3c3840'],
                                    [1, '#3C3840']
                                ]
                            }
                        },
                        legend: true,
                        yAxis: {
                            min: 0,
                            max: 100,
                            title: {
                                text: yName
                            }
                        },
                        xAxis: {
                            categories: this.state.chartX
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0.2,
                                borderWidth: 0,
                                events: {
                                    click: function (e) {

                                        self.buildTestChart(e.point);
                                    }
                                }
                            }
                        },
                        series: statisticDiagram

                    }
                )
            }
        }
        
    };

    renderTestDate = (props, state) => {
        if(props.courseUser[0].testDate){
            this.setState({testDateConfirmed: props.courseUser[0].testDate, viewLoaded: true}, () => {
                let data = [];
                // Get last End Date or today:
                let lastSubject = (props.us.filter(s => s.completed && s.active).length > 0) ? props.us.filter(s => s.completed && s.active)[props.us.filter(s => s.active && s.completed).length - 1] : null;
                let lastEndDate = (lastSubject) ? moment(lastSubject.completedOn) : moment();
                props.courseUser[0].subjectOrder.map((so, i) => {
                    
                    let subject = props.course.CourseSubject.filter(s => s.id === so)[0];
                    let dateRange = '';
                    if(subject){
                    if(subject.id === props.courseUser[0].currentSubject){
                        let current = moment();
                        if(props.courseUser[0].currentSubjectStart){
                            current = moment(props.courseUser[0].currentSubjectStart);
                        }else if(props.us.filter(s => s.completed && s.active).length > 0){
                            current = moment(props.us.filter(s => s.completed && s.active)[props.us.filter(s => s.active && s.completed).length - 1].completedOn);
                            
                        }
                        
                        
                        let subjectDateSplit = props.courseUser[0].currentSubjectDeadline;
                        let end = moment(subjectDateSplit);
                        lastEndDate = end;
                        
                        while(end.diff(current, 'days') >= 0){
                            let newDate = current.format('YYYY-MM-DD');
                            let d = {date: newDate, classname: 'bg-sub-' + i};
                             data.push(d);
                             current.add(1, 'days');
                        }
                        lastEndDate.add(1, 'days');
                        //dateRange = current.format('MMM DD') + ' - ' + end.format('MMM DD');
                        
                    }else if(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id).length === 0){
                        // Not completed yet, future course
                        let lastEnd = moment(this.state.subjectDate.split('_')[1]);
                        let courseEnd = moment(this.props.courseUser[0].testDate);
                        let subjectsCompleted = this.props.us.filter(s => s.completed && s.active).length;
                        let subjectsToComplete = this.props.courseUser[0].subjectOrder.length;
        
                        let subjectsRemaining = subjectsToComplete - subjectsCompleted;
                        let currentSubjectIndex = this.props.courseUser[0].subjectOrder.indexOf(this.props.courseUser[0].currentSubject);
                        if(i > currentSubjectIndex){
                            // After current subject;
                            let current = moment(lastEndDate.format('YYYY-MM-DD'));
                            let end = moment(lastEndDate.format('YYYY-MM-DD')).add(subject.duration - 1, 'days');
                            
                            while(end.diff(current, 'days') >= 0){
                                let newDate = current.format('YYYY-MM-DD');
                                let d = {date: newDate, classname: 'bg-sub-' + i};
                                 data.push(d);
                                 current.add(1, 'days');
                            }
                            
                            dateRange = lastEndDate.add(subject.duration, 'days');
        
                        }
                    }else if(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id).length > 0){
                        dateRange = moment(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id).subjectStarted).format('MMM DD') + ' - ' + moment(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id).completedOn).format('MMM DD')
                    }
                    
                }
                return true;
                });
                
                let testDate = moment(props.courseUser[0].testDate).format('YYYY-MM-DD');
                if(data.filter(d => d.date === testDate).length > 0 && props.courseUser[0].testDate){
                    let subject = props.course.CourseSubject.filter(s => s.id === props.courseUser[0].currentSubject)[0];
                    
                    NotificationManager.error('You would not meet your test date with this timeline.');
                    this.setState({subjectDate: "sdsds_" + moment().add(parseInt(subject.duration) - 1, 'days').format('YYYY-MM-DD')});
                }
                
                
                if(props.courseUser[0].testDate){
                    data.push({date: moment(props.courseUser[0].testDate).format('YYYY-MM-DD'), classname: 'day-selected-for-test'});
                }
                
                let td = props.courseUser[0].testDate.toString().split('T')[0];
                let self = this;
                $('.calendar_1').html('<div id="test_calendar"></div>');
                $("#test_calendar").empty();
                $("#test_calendar").zabuto_calendar({
                    cell_border:false,
                    /*legend: [
                        {type: "block", label: "Deadline Days", classname: "bg-grey"},
                        {type: "block", label: "Expected Deadline", classname: "bg-orange"},
                        {type: "block", label: "Exam Day", classname: "bg-purple"},
                        {type: "block", label: "Graduation", classname: "bg-success"},
                    ],*/
                    action: function () {
                        if(self.state.canResetTestDate){
                            let split_date = this.id.split('_');
                            let d = moment(split_date[split_date.length - 1]);
                            let today = moment(new Date());

                            let lengthOfCourse = 0;
                            self.props.course.CourseSubject.map(s => {
                                if(s.duration){
                                    lengthOfCourse += s.duration;
                                }
                            });
                            let earliestTestDate = moment().add(lengthOfCourse, 'days');
                            
                            if(d.diff(today, 'days') < 0){
                                NotificationManager.error('You cannot set your test date to a past date.');
                            }else if(d.diff(today, 'days') > lengthOfCourse){
                                 NotificationManager.error('You would not have time to complete this course if you choose that date.');
                            }else{
                                return self.setTestDate(this.id, false);
                            }
                        }else{
                            
                            NotificationManager.error("You've already set a test date.");
                        }
                    },
                    data: data
                });
            });

        }else if(!props.courseUser[0].testDate){
            let self = this;
            let lengthOfCourse = 0;
            let daysTilTest = 0;
            let data = [];
                            
            props.course.CourseSubject.map(s => {
                if(s.duration){
                    lengthOfCourse += parseInt(s.duration);
                    daysTilTest += parseInt(s.duration);
                }
            });
            
            let current = moment();
            
            while(daysTilTest >= 0){
                data.push({date: current.format('YYYY-MM-DD'), classname: 'bg-danger'});
                current.add(1, 'days');
                daysTilTest--;
            }
            
            this.setState({viewLoaded: true}, () => {
                $('.calendar_1').html('<div id="test_calendar"></div>');
                $("#test_calendar").empty();
                $("#test_calendar").zabuto_calendar({
                    cell_border: false,
                    /*legend: [
                        {type: "block", label: "Deadline Days", classname: "bg-grey"},
                        {type: "block", label: "Expected Deadline", classname: "bg-orange"},
                        {type: "block", label: "Exam Day", classname: "bg-purple"},
                        {type: "block", label: "Graduation", classname: "bg-success"},
                    ],*/
                    action: function () {
                    if(self.state.view !== 'attendance'){
                        let split_date = this.id.split('_');
                        let d = moment(split_date[split_date.length - 1]);
                        let today = moment(new Date());

                            
                            let earliestTestDate = moment().add(lengthOfCourse, 'days');
                            if(today.diff(d, 'days') > 0){
                                NotificationManager.error('You cannot set your test date to a past date.');
                            }else if(d.diff(today, 'days') < lengthOfCourse){
                               NotificationManager.error('You would not have time to complete this course if you choose that date.');
                            }else{
                                return self.setTestDate(this.id, false);
                            }
                    }
                },
                data: data
                });
            });
        }

    }

    sameMonth = (a, b, other) => {
        if (a.month() !== b.month()) {
            return other;
        }
        return a.date();
    }

    getWeeks = (m) => {
        let lastOfMonth     = m.clone().endOf('month'),
            lastOfMonthDate = lastOfMonth.date(),
            firstOfMonth    = m.clone().startOf('month'),
            currentWeek     = firstOfMonth.clone().day(0),
            output          = [],
            startOfWeek,
            endOfWeek;

        while (currentWeek < lastOfMonth) {
            startOfWeek = this.sameMonth(currentWeek.clone().day(0), firstOfMonth, 1);
            endOfWeek = this.sameMonth(currentWeek.clone().day(6), firstOfMonth, lastOfMonthDate);

            output.push({start: startOfWeek, end: endOfWeek});
            currentWeek.add('d', 7);
        }

        return output;
    }



    buildChart = (view) => {
        let data = [];
        let chartX = [];
        let chartType = 'bar';
        let {attendanceHours, currentSubject} = this.state;
        
        if(view){
            if(this.props.courseUser[0]){
                if(view === 'quiz' && currentSubject && currentSubject !== 'all'){
                    if(this.props.courseUser[0].stats[view].subjects){
                        if(this.props.courseUser[0].stats[view].subjects[currentSubject]){
                            data = this.props.courseUser[0].stats[view].subjects[currentSubject].chart;
                            chartX = this.props.courseUser[0].stats[view].subjects[currentSubject].chartX;
                            chartType = this.props.courseUser[0].stats[view].subjects[currentSubject].chartType;
                        }
                    }
                }else{
                    if(this.props.courseUser[0].stats[view]){
                     data = this.props.courseUser[0].stats[view].chart;
                        chartX = this.props.courseUser[0].stats[view].chartX;
                        chartType = this.props.courseUser[0].stats[view].chartType;
                    }
                }
            }
        }

        if(view === 'attendance'){
            if(this.props.courseUser[0].stats.attendanceHours){
                attendanceHours = this.props.courseUser[0].stats.attendanceHours.chart;
            }else{
                attendanceHours = [{data: [], name: 'Attendance'}];
            }
        }
        
        this.setState({chart: data, chartX, chartType, viewLoaded: true, attendanceHours});

    }
    
    updateTimer = () => {
        this.setState({timeLeft: this.state.timeLeft - 1, estimatedTime: this.state.estimatedTime + 1, timeToTest: this.state.timeToTest - 1});
    }
    
    componentDidUpdate(props, state){
        if(!this.props.courseUser){
            return false;
        }
        if(!this.props.match.params.courseId && this.props.courseUser[0].id){
            this.props.history.push('/dashboard/' + this.props.course.id);
        }

        this.initialize(props, state);

    }

    componentWillUnmount(){
        let {currentLog} = this.props;
        if(currentLog){
            currentLog.end = new Date();
            this.props.updateLog(currentLog, this.props.user.id);
        }
    }




    initialize = (props, state) => {
        let cuUpdated = false;

        if(!this.props.courseUser){
            return false;
        }
        if(this.props.courseUser && !props.courseUser){
            cuUpdated = true;
        }else if(props.courseUser){
            if(this.props.courseUser[0]){
                if(this.props.courseUser[0] !== props.courseUser[0]){
                    cuUpdated = true;
                }
            }
        }

        if(this.props.course && !props.course){
            cuUpdated = true;
        }

        let {currentSubject, studiedLastMonth, studiedTotal, studiedAverage, subjectDate} = this.state;

        if(props.match.params.courseId !== this.props.match.params.courseId){
            this.props.getSingleCourseUser(this.props.user.user.Profile.id, this.props.match.params.courseId, this.props.user.id);
            this.props.getCourseAndSubjects(this.props.match.params.courseId, this.props.user.id);
            
        }

        if(this.props.courseUser[0].id !== props.courseUser[0].id){
            this.props.getCompletedSubjects(this.props.courseUser[0].id, this.props.user.id);
            cuUpdated = true;
        }
        
        if(!this.props.courseUser[0].id){
            if(this.props.allCourseUsers.length > 0){
                if(!this.props.match.params.courseId){
                    this.props.history.push('/dashboard/' + this.props.allCourseUsers[0].Course.id);
                }
            }
            
        }else if(this.props.course){
            
        if(this.props.profile){
            if(!this.props.profile.tourComplete && state.stepsEnabled === null){
                this.setState({stepsEnabled: true});    
            }
        }
            
        if(cuUpdated && this.props.courseUser[0]){
            // If no task for deadline:
            if(this.props.tasks){
                let tasks = this.props.tasks.filter(t => t.generated === 'testDate');
                if(tasks.length === 0){
                    let  task = {
                        title: 'Set Test Date', 
                        value: [],
                        generated: 'testDate',
                        date: moment(),
                        progress: 0, 
                        currentIndex: 0, 
                        profileId: this.props.profile.id, 
                        courseId: this.props.course.id, 
                        courseUserId: this.props.courseUser[0].id
                        
                    };
                    let command = jwt.sign({
                        command: {
                        type: 'SEND_TASK',
                            courseUserId: task.courseUserId,
                            task: task,
                            token: props.user.id
                        }}, '#&r7%+UbWU8Hc');
                        if(props.socket.readyState){
                            props.socket.send(command)
                        }
                    
                }
            }
            
            
           if(this.props.profile){
                if(this.props.profile.onboardingStep < 6 && this.props.profile.role === 'student'){
                    props.history.push('/on-boarding');
                    return false;
                }
            }
            
            
            if(!this.state.setTimer || this.props.courseUser[0].testDate !== props.courseUser[0].testDate || this.props.courseUser[0].currentSubjectDeadline !== state.subjectDate || 
                this.props.courseUser[0].id !== props.courseUser[0].id){
                    // console.log("initializing");
                    this.props.getFlags(this.props.courseUser[0], this.props.user.id);
                    let secondsLeft = moment.duration(moment(this.props.courseUser[0].currentSubjectDeadline).diff(moment())).as('seconds');
                    let timeTaken = moment.duration(new Date() - new Date(this.props.courseUser[0].currentSubjectStart)).as('seconds');

                    let videosInCourse = this.props.courseUser[0].videosInSubject || 0;

                    // console.log(secondsLeft, moment(this.props.courseUser[0].currentSubjectDeadline), moment())

                      // Days from start to deadline
                      let totalDiff = moment.duration(moment(new Date(this.props.courseUser[0].currentSubjectDeadline)).diff(moment(this.props.courseUser[0].currentSubjectStart))).as('days'); // (deadline - started) / (1000);
                      
                      // Days from start to now
                      let actualDiff = moment.duration(moment(new Date()).diff(moment(this.props.courseUser[0].currentSubjectStart))).as('days');
                      let completedVideos = this.props.courseUser[0].completedVideos || 0;
            
                      // How many videos must be completed per day to meet deadline:
                      let estimatedAverage =  videosInCourse / Math.ceil(totalDiff);
                      // How many videos are being completed per day on average
                      
                      let requiredPerDay = Math.ceil(estimatedAverage);
                      let actualAverage = completedVideos / Math.ceil(actualDiff);
                       
                      let estimatedDays = videosInCourse / actualAverage;
                       // avg completed = completed / (86400 * daysSinceStart) (1 day) = 2
                      // estimatedComplete = avg (2) * daysRemaining
                      
                      let estimatedSecondsToComplete;
                       if(actualDiff !== Infinity){
                          if(actualDiff > 0){
                            //let s = 86400 * estimatedAverage;
                            estimatedSecondsToComplete = moment.duration(estimatedDays*86400*1000).as('seconds');
                          }
                      }

                      let estimatedTimeClass = 'green';
            
                        if(secondsLeft === 0){
                            estimatedTimeClass = 'red';
                        }else if (estimatedSecondsToComplete < secondsLeft) {
                            estimatedTimeClass = 'green';
                      }else if(estimatedSecondsToComplete > secondsLeft){
                          estimatedTimeClass = 'yellow';
                      }
                      
                      let timeToTest = -1;
                      if(this.props.courseUser[0].testDate){
                          timeToTest = moment.duration(moment(this.props.courseUser[0].testDate).diff(moment())).as('seconds');
                      }

                    this.setState({setTimer: true, timeLeft: secondsLeft, timeTaken: timeTaken, estimatedTime: estimatedSecondsToComplete, estimatedTimeClass: estimatedTimeClass, timeToTest, requiredPerDay}, () => {

                        
                    })


                    
                }
            
            
            if(this.props.courseUser[0].testDate && !this.props.courseUser[0].completedCourse){
                let td = moment(this.props.courseUser[0].testDate);
                let today = moment(new Date());
             
                if(today.diff(td, 'days') >= 0 && this.state.canResetTestDate === false){
                    
                    this.setState({canResetTestDate: true});
                }else if(today.diff(td, 'days') < 0 && this.state.canResetTestDate === true){
                        this.setState({canResetTestDate: false});
                    
                }
            }
            
            

            if(currentSubject === null){
                currentSubject = this.props.courseUser[0].currentSubject;
                let subject = this.props.course.CourseSubject.filter(s => s.id === currentSubject)[0];
                if(subject){
                    if(!this.props.courseUser[0].currentSubjectDeadline && !subjectDate && subject.duration){
                        let d = moment().add(subject.duration - 1, 'days');
                        subjectDate = 'zabutocalendar_' + d.format('YYYY-MM-DD');
                    }
                }
            }

            if(studiedLastMonth === null && this.props.courseUser[0].id){
                let d = parseInt(moment(new Date()).subtract(1, 'months').format('MM'));
                let studiedDates = [];
                if(this.props.courseUser[0].studied){
                    this.props.courseUser[0].studied.map(a => {
                        let item = parseInt(moment(a.date).format('MM'));
                        if(item === d) {
                            let dayToPush = moment(a.date).format('DD');
                            if (studiedDates.indexOf(dayToPush) === -1) {

                                studiedDates.push(dayToPush);
                            }
                        }
                    });
                }

                studiedLastMonth = studiedDates.length;
                studiedLastMonth = studiedDates.length.toString() + ' days (' + Math.floor((studiedDates.length / parseInt(moment(new Date()).subtract(1, 'months').daysInMonth())) * 100) + '%)';
            }

            if(studiedTotal === null && this.props.courseUser[0].id){
                let c = moment(this.props.courseUser[0].created);
                let today = moment();

                let totalDays = today.diff(c, 'days') + 1;
                let daysStudied = [];

                if(this.props.courseUser[0].studied){
                    this.props.courseUser[0].studied.map(a => {
                        let dayToPush = moment(a.date).format('YYYY-MM-DD');
                        if (daysStudied.indexOf(dayToPush) === -1) {
                            daysStudied.push(dayToPush);
                        }
                    });
                }
                
                let stp = Math.floor((daysStudied.length / totalDays) * 100);
                if(stp === Infinity){
                    stp = 100;
                }
                if(isNaN(stp)){
                    stp = 0;
                }

                studiedTotal = daysStudied.length.toString() + ' days (' + stp + '%)';
            }

            if(studiedAverage === null){
                let c = moment(this.props.courseUser[0].created);
                let today = moment();

                let totalDays = today.diff(c, 'days');

                let timeStudied = 0;
                let studiedVsTotal;
                if(this.props.courseUser[0].studied){
                    this.props.courseUser[0].studied.map(part => {
                        timeStudied += part.time;
                    });
                
                
                    studiedVsTotal = timeStudied / this.props.courseUser[0].studied.length;
                }
                if(isNaN(studiedVsTotal)){
                    studiedVsTotal = 0;
                }

                studiedAverage = (studiedVsTotal / 60 / 60).toFixed(2).toString() + ' Hours';

            }
            
            if(this.props.courseUser[0].improvement){


                this.setState({improvement: this.props.courseUser[0].improvement, currentSubject, studiedTotal, studiedLastMonth, studiedAverage, subjectDate});
            }



            if(this.state.completionPercent === null && this.props.courseUser[0]){
                let completionPercent = 0;
                if(this.props.courseUser[0].completionPercent){
                    completionPercent = this.props.courseUser[0].completionPercent;
                }
    
                this.setState({completionPercent});
            }
        }
            
            
            if(this.props.courseUser[0].id) {
                if(this.props.courseUser[0].testDate && !this.state.testDateConfirmed){
                    let data = [];
                    // Get last End Date or today:
                    let lastSubject = (this.props.us.filter(s => s.completed).length > 0) ? this.props.us.filter(s => s.completed)[this.props.us.filter(s => s.completed).length - 1] : null;
                    let lastEndDate = (lastSubject) ? moment(lastSubject.completedOn) : moment();
                    this.props.courseUser[0].subjectOrder.map((so, i) => {
                        
                        let subject = this.props.course.CourseSubject.filter(s => s.id === so)[0];
                        let dateRange = '';
                        if(subject){
                        if(subject.id === this.props.courseUser[0].currentSubject){
                            let current = moment();
                            if(this.props.courseUser[0].currentSubjectStart){
                                current = moment(this.props.courseUser[0].currentSubjectStart);
                            }else if(this.props.us.filter(s => s.completed && s.active).length > 0){
                                current = moment(this.props.us.filter(s => s.completed)[this.props.us.filter(s => s.completed).length - 1].completedOn);
                                
                            }
                            
                            
                            let subjectDateSplit = state.subjectDate.split('_')
                            let end = moment(subjectDateSplit[subjectDateSplit.length - 1]);
                            lastEndDate = end;
                            
                            while(end.diff(current, 'days') >= 0){
                                let newDate = current.format('YYYY-MM-DD');
                                let d = {date: newDate, classname: 'bg-sub-' + i};
                                 data.push(d);
                                 current.add(1, 'days');
                            }
                            lastEndDate.add(1, 'days');
                            //dateRange = current.format('MMM DD') + ' - ' + end.format('MMM DD');
                            
                        }else if(this.props.us.filter(s => s.completed).filter(s => s.courseSubjectId === subject.id).length === 0){
                            // Not completed yet, future course
                            let lastEnd = moment((lastSubject) ? lastSubject.completedOn : new Date());
                            let courseEnd = moment(this.props.courseUser[0].testDate);
                            let subjectsCompleted = this.props.us.filter(s => s.completed && s.active).length;
                            let subjectsToComplete = this.props.courseUser[0].subjectOrder.length;
            
                            let subjectsRemaining = subjectsToComplete - subjectsCompleted;
                            let currentSubjectIndex = this.props.courseUser[0].subjectOrder.indexOf(this.props.courseUser[0].currentSubject);
                            if(i > currentSubjectIndex){
                                // After current subject;
                                let current = moment(lastEndDate.format('YYYY-MM-DD'));
                                let end = moment(lastEndDate.format('YYYY-MM-DD')).add(subject.duration - 1, 'days');
                                
                                while(end.diff(current, 'days') >= 0){
                                    let newDate = current.format('YYYY-MM-DD');
                                    let d = {date: newDate, classname: 'bg-sub-' + i};
                                     data.push(d);
                                     current.add(1, 'days');
                                }
                                
                                dateRange = lastEndDate.add(subject.duration, 'days');
            
                            }
                        }else if(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id).length > 0){
                            dateRange = moment(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id).subjectStarted).format('MMM DD') + ' - ' + moment(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id).completedOn).format('MMM DD')
                        }
                    }
                    });
                    
                    let testDate = moment(this.props.courseUser[0].testDate).format('YYYY-MM-DD');
                    if(data.filter(d => d.date === testDate).length > 0 && this.props.courseUser[0].testDate){
                        let subject = {};
                        if(this.props.courseUser[0].currentSubject){
                            subject = this.props.course.CourseSubject.filter(s => s.id === this.props.courseUser[0].currentSubject)[0];
                        }
                        NotificationManager.error('You would not meet your test date with this timeline.');
                        this.setState({subjectDate: "sdsds_" + moment().add(parseInt(subject.duration) - 1, 'days').format('YYYY-MM-DD')});
                    }
                    
                    
                    if(this.props.courseUser[0].testDate){
                        data.push({date: moment(this.props.courseUser[0].testDate).format('YYYY-MM-DD'), classname: 'day-selected-for-test'});
                    }
                    
                    this.setState({testDateConfirmed: this.props.courseUser[0].testDate}, () => {
                        /*
                        let td = this.props.courseUser[0].testDate.toString().split('T')[0];
                        let self = this;
                        $("#test_calendar").zabuto_calendar({
                            cell_border:false,
                            
                            action: function () {
                                if(self.state.view !== 'attendance'){
                                    NotificationManager.error("You've already set a test date.");
                                }
                            },
                            data: data
                        });
                        
                        */
                    });
        
                }else if(!this.props.courseUser[0].testDate){
                    let self = this;
                    $("#test_calendar").zabuto_calendar({
                        cell_border:false,
                        /*legend: [
                            {type: "block", label: "Deadline Days", classname: "bg-grey"},
                            {type: "block", label: "Expected Deadline", classname: "bg-orange"},
                            {type: "block", label: "Exam Day", classname: "bg-purple"},
                            {type: "block", label: "Graduation", classname: "bg-success"},
                        ],*/
                        action: function () {
                            if(self.state.view !== 'attendance'){
                                let split_date = this.id.split('_');
                                let d = moment(split_date[split_date.length - 1]);
                                let today = moment(new Date());
                                let lengthOfCourse = 0;
                                self.this.props.course.CourseSubject.map(s => {
                                    if(s.duration){
                                        lengthOfCourse += s.duration;
                                    }
                                });
                                let earliestTestDate = moment().add(lengthOfCourse, 'days');
                                
                                if(d.diff(today, 'days') > 0){
                                    NotificationManager.error('You cannot set your test date to a past date.');
                                }else if(d.diff(today, 'days') > lengthOfCourse){
                                    NotificationManager.error('You would not have time to complete this course if you choose that date.');
                                }else{
                                    
                                    return self.setTestDate(this.id, false);
                                }
                            }
                        }
                    });
                }
            }
            
            if(this.props.courseUser[0]){
            
            if(this.state.subjectDate !== state.subjectDate || this.props.courseUser[0].testDate !== this.props.courseUser[0].testDate){
            
            
            if(this.props.courseUser[0].currentSubjectDeadline && !this.state.subjectDateConfirmed || state.timeLeft <= 0){
                let self = this;
    
                let data = [];
                let beginRemaining;
                if(state.subjectDate){
                    let split_date = state.subjectDate.split('_');
                    split_date = split_date[split_date.length - 1];
    
                    beginRemaining = moment(split_date);
                    let fromNowToEnd = beginRemaining.diff(moment(), 'days');
    
                    while(fromNowToEnd >= 0){
                        let newDate = moment(beginRemaining).subtract(fromNowToEnd, 'days').format('YYYY-MM-DD');
                        let d = {date: newDate, classname: 'bg-primary'};
                        data.push(d);
    
                        fromNowToEnd--;
                    }
                }else{
                    beginRemaining = moment();
                }
    
    
                let remaining = moment(this.props.courseUser[0].testDate).diff(beginRemaining, 'days');
                remaining -= 1;
    
                while(remaining > 0){
                    let newDate = moment(this.props.courseUser[0].testDate).subtract(remaining, 'days').format('YYYY-MM-DD');
                    let d = {date: newDate, classname: 'bg-danger'};
                    data.push(d);
                    remaining--;
                }
    

            }else if(!this.props.courseUser[0].currentSubjectDeadline || this.state.subjectDate !== state.subjectDate || this.props.courseUser[0].currentSubjectDeadline !== this.props.courseUser[0].currentSubjectDeadline){
                let self = this;
    
    
                let data = [];
                let beginRemaining;
                
                
                // Get last End Date or today:
                let lastSubject = (this.props.us.filter(s => s.completed && s.active).length > 0) ? this.props.us.filter(s => s.completed && s.active)[this.props.us.filter(s => s.active && s.completed).length - 1] : null;
                let lastEndDate = (lastSubject) ? moment(lastSubject.completedOn) : moment();
                this.props.courseUser[0].subjectOrder.map((so, i) => {
                    
                    let subject = this.props.course.CourseSubject.filter(s => s.id === so)[0];
                    let dateRange = '';
                    if(subject){
                    if(subject.id === this.props.courseUser[0].currentSubject){
                        let current = moment();
                        
                        let subjectDateSplit = state.subjectDate.split('_')
                        let end = moment(subjectDateSplit[subjectDateSplit.length - 1]);
                        lastEndDate = end;
                        
                        while(end.diff(current, 'days') >= 0){
                            let newDate = current.format('YYYY-MM-DD');
                            let d = {date: newDate, classname: 'bg-sub-' + i};
                             data.push(d);
                             current.add(1, 'days');
                        }
                        lastEndDate.add(1, 'days');
                        //dateRange = current.format('MMM DD') + ' - ' + end.format('MMM DD');
                        
                    }else if(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id).length === 0){
                        // Not completed yet, future course
                        let lastEnd = moment(this.state.subjectDate.split('_')[1]);
                        let courseEnd = moment(this.props.courseUser[0].testDate);
                        let subjectsCompleted = this.props.us.filter(s => s.completed && s.active).length;
                        let subjectsToComplete = this.props.courseUser[0].subjectOrder.length;
        
                        let subjectsRemaining = subjectsToComplete - subjectsCompleted;
                        let currentSubjectIndex = this.props.courseUser[0].subjectOrder.indexOf(this.props.courseUser[0].currentSubject);
                        if(i > currentSubjectIndex){
                            // After current subject;
                            let current = moment(lastEndDate.format('YYYY-MM-DD'));
                            let end = moment(lastEndDate.format('YYYY-MM-DD')).add(subject.duration - 1, 'days');
                            
                            while(end.diff(current, 'days') >= 0){
                                let newDate = current.format('YYYY-MM-DD');
                                let d = {date: newDate, classname: 'bg-sub-' + i};
                                 data.push(d);
                                 current.add(1, 'days');
                            }
                            
                            dateRange = lastEndDate.add(subject.duration, 'days');
        
                        }
                    }else if(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id).length > 0){
                        let curSubject = this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id)[0];
                        
                        // Rendering completed subject:
                        let current = moment(curSubject.subjectStarted);
                        let end = moment(curSubject.completedOn);
                        while(end.diff(current, 'days') >= 0){
                                let newDate = current.format('YYYY-MM-DD');
                                let d = {date: newDate, classname: 'bg-sub-' + i};
                                 data.push(d);
                                 current.add(1, 'days');
                            }
                        
                        dateRange = moment(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id).subjectStarted).format('MMM DD') + ' - ' + moment(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id).completedOn).format('MMM DD')
                    }
                    }
                });
                
                let testDate = moment(this.props.courseUser[0].testDate).format('YYYY-MM-DD');
                if(data.filter(d => d.date === testDate).length > 0 && this.props.courseUser[0].testDate){
                    let subject = {};
                    if(this.props.courseUser[0].currentSubject){
                        subject = this.props.course.CourseSubject.filter(s => s.id === this.props.courseUser[0].currentSubject)[0];
                    }
                    
                    NotificationManager.error('You would not meet your test date with this timeline.');
                    this.setState({subjectDate: "sdsds_" + moment().add(parseInt(subject.duration) - 1, 'days').format('YYYY-MM-DD')});
                }
                
                
                if(this.props.courseUser[0].testDate){
                    data.push({date: moment(this.props.courseUser[0].testDate).format('YYYY-MM-DD'), classname: 'day-selected-for-test'});
                }
                
                /*
                //OLD

                if(state.subjectDate){
                    let split_date = state.subjectDate.split('_');
                    split_date = split_date[split_date.length - 1];
    
                    beginRemaining = moment(split_date);
                    let fromNowToEnd = beginRemaining.diff(moment(), 'days');
                    while(fromNowToEnd >= 0){
                        let newDate = moment(beginRemaining).subtract(fromNowToEnd, 'days').format('YYYY-MM-DD');
                        let d = {date: newDate, classname: 'bg-primary'};
                        data.push(d);
    
                        fromNowToEnd--;
                    }
                }else{
                    beginRemaining = moment();
                }
    
    
                let remaining = moment(this.props.courseUser[0].testDate).diff(beginRemaining, 'days');
                remaining -= 1;
    
                while(remaining > 0){
                    let newDate = moment(this.props.courseUser[0].testDate).subtract(remaining, 'days').format('YYYY-MM-DD');
                    let d = {date: newDate, classname: 'bg-danger'};
                    data.push(d);
                    remaining--;
                }
                */
    
                
            }
            
            }
            }
            
            // End cuupdated


        

        if(this.props.courseUser[0]) {
            if (this.props.courseUser[0].currentSubjectDeadline && !state.subjectDateConfirmed) {
                this.setState({subjectDateConfirmed: true});
            }
        }

        


    }

    }

    componentWillUpdate(props, state){
        let nonCharts = ['test'];
        if(this.state.view !== state.view && state.viewLoaded === false && nonCharts.indexOf(state.view) === -1){
            this.buildChart(state.view);
        }else if(state.view === 'attendance' && this.state.view === 'attendance' && state.attendanceType !== this.state.attendanceType){
            this.buildChart(state.view);
        }


        if(this.state.attentivePercent === null){
            let attentivePercent = 0;
            if(this.props.courseUser.length > 0){
                if(this.props.courseUser[0].attentivePercent){
                    attentivePercent = this.props.courseUser[0].attentivePercent;
                    this.setState({attentivePercent});
                }
                
                
            }
            
        }

        





        if(props.courseUser !== this.props.courseUser && state.view === 'attendance' || state.view === 'attendance' && state.viewLoaded === false){
            this.renderAttendance(props, state);
        }else if(state.view === 'test' && this.state.view !== 'test' && state.viewLoaded === false){
            this.renderTestDate(props, state);
        }
    }
    
    afterSetTestDate = () => {
        let testDateTask = this.props.tasks.filter(t => t.generated === 'testDate');
        if(testDateTask.length > 0){

            testDateTask = testDateTask[0];
            testDateTask.progress = 100;

            
            let command = jwt.sign({
                        command: {
                           type: 'UPDATE_TASK',
                            task: testDateTask,
                            profileId: this.props.profile.id,
                            token: this.props.user.id
                        }}, '#&r7%+UbWU8Hc');
            this.props.socket.send(command)
        }
        let tasks = this.props.tasks.filter(t => t.generated === 'deadline');
        if(tasks.length === 0){
            let  task = {
                title: 'Set Subject Deadline', 
                value: [],
                generated: 'deadline',
                date: moment(),
                progress: 0, 
                currentIndex: 0, 
                profileId: this.props.profile.id, 
                courseId: this.props.course.id, 
                courseUserId: this.props.courseUser[0].id
                
            };
            let command = jwt.sign({
                        command: {
                          type: 'SEND_TASK',
                            courseUserId: task.courseUserId,
                            task: task,
                            token: this.props.user.id
                        }}, '#&r7%+UbWU8Hc');
            this.props.socket.send(command)
            
        }
    }
    
    afterSetDeadline = () => {
         let tasks = this.props.tasks.filter(t => t.generated === 'deadline');
        if(tasks.length > 0){
            let task = tasks[0];
            task.progress = 100;
            
            let command = jwt.sign({
                        command: {
                           type: 'UPDATE_TASK',
                            task: task,
                            profileId: this.props.profile.id,
                            token: this.props.user.id
                        }}, '#&r7%+UbWU8Hc');
            this.props.socket.send(command)
            
        }
        
        let self = this;
        setTimeout(function(){
             let command = jwt.sign({
                        command: {
                           type: 'GET_DAILY_TASKS',
                            id: self.props.courseUser[0].profileId,
                            courseUserId: self.props.courseUser[0].id,
                            token: self.props.user.id
                        }}, '#&r7%+UbWU8Hc');
            self.props.socket.send(command)     
        }, 2000);
       
        
    }

    setCourseUserTestDate = () => {
        if(!this.props.courseUser[0].testDate || this.state.canResetTestDate === true) {
            $("#" + this.state.testDate).find(".day").addClass("day-selected-for-test");
            let cu = this.props.courseUser[0];
            cu.testDate = new Date(this.state.testDate.split("_")[3] + " 23:59:59");
            this.props.updateCourseUser(cu, this.props.user.user.Profile.id, this.props.user.id);
            
            // Update test task if exists and create subject deadline task:
            this.afterSetTestDate();
        }else{
            NotificationManager.error("You've already set a test date.");
        }
        this.setState({confirmTestDateModal: false});
    }

    setCourseUserSubjectDate = () => {
        if(!this.props.courseUser[0].currentSubjectDeadline || moment(this.props.courseUser[0].currentSubjectDeadline).diff(moment(), 'days') < 0 || this.state.timeLeft < 0) {
            $("#" + this.state.testDate).find(".day").addClass("day-selected-for-test");
            let cu = this.props.courseUser[0];
            cu.currentSubjectDeadline = new Date(this.state.subjectDate.split("_")[this.state.subjectDate.split("_").length - 1] + " 23:59:59");
            cu.currentSubjectStart = new Date();
            this.props.updateCourseUser(cu, this.props.user.user.Profile.id, this.props.user.id);
            let subject = this.props.course.CourseSubject.filter(s => s.id === this.props.courseUser[0].currentSubject);
            
            let daysUntilSubjectEnd = moment(cu.currentSubjectDeadline).diff(moment(), 'days');
            /*
            this.props.socket.send(JSON.stringify({
                type: 'ADD_USER_TO_THREAD',
                subjectId: subject[0].id,
                profileId: this.props.user.user.Profile.id
            }));
            */
            
            this.afterSetDeadline();
            
            let existingThread = this.props.threads.filter(t => t.subjectId === subject[0].id && t.users.indexOf(this.props.user.user.Profile.id) > -1 && !t.ticket);
             let thread = {
                users: [this.props.user.user.Profile.id],
                createdAt: new Date(),
                subjectId: subject[0].id,
                courseId: subject[0].courseId,
                status: 1,
                lastActivity: new Date(),
                subjectName: subject[0].name
            }
            
            if(existingThread.length > 0){
                thread.id = existingThread[0].id;   
            }
            
           
            
            
            let command = jwt.sign({
                            command: {
                              type: 'CREATE_THREAD',
                              thread: thread,
                                token: this.props.user.id
                            }}, '#&r7%+UbWU8Hc');
            this.props.socket.send(command)
            NotificationManager.success("Great! You have " + daysUntilSubjectEnd.toString() + " days to finish " + subject[0].name);
            $('#SetDeadLineModal').modal('hide').removeClass('in');
        }else{
            NotificationManager.error("You've already set a test date.");
        }
        this.setState({confirmSubjectDateModal: false});
    }

    setTestDate = (id, fromModal) => {
        let hasEvent = $("#" + id).data("hasEvent");
        if (this.props.courseUser[0].testDate && this.state.canResetTestDate === false) {
            //alert("You clicked on an event");
            return false;
        }else{
            this.setState({confirmTestDateModal: true, testDate: id})
        }
        return true;

    }

    setSubjectDeadline = (id, fromModal) => {
        let hasEvent = $("#" + id).data("hasEvent");
        if (this.props.courseUser[0].currentSubjectDeadline) {
            //alert("You clicked on an event");
            return false;
        }else{
            this.setState({subjectDate: id})
        }
        return true;
    }

    //LifecycleMethods
    componentDidMount() {
        this.props.hideLoader();
        if(this.props.courseUser){

            let newLog = {
                date: new Date(),
                duration: 0,
                type: 'Dashboard',
                subject: '',
                chapter: '',
                activity: '',
                score: 'NA',
                courseUserId: this.props.courseUser[0].id,
                userId: this.props.user.user.id
            }

            this.props.createLog(newLog, this.props.user.id);

            this.props.getLocation();

            if(this.props.profile.onboardingStep < 7 && this.props.user.user.role === "student"){
                this.props.history.push(`/on-boarding`)
            }

            if(["instructor", "admin"].indexOf(this.props.profile.role) > -1){
                this.props.history.push('/dashboard-admin');
            }

            let self = this;
        }

            this.props.onLoad(this.props.user.user.Profile.id, this.props.match.params.courseId, this.props.user.id);
            if(this.props.match.params.courseId){
                this.props.getSingleCourseUser(this.props.user.user.Profile.id, this.props.match.params.courseId, this.props.user.id);
            }
        
        if(this.props.courseUser[0].id){
            let {currentSubject, studiedLastMonth, studiedTotal, studiedAverage, subjectDate} = this.state;
            if(!this.state.setTimer){
                    this.props.getFlags(this.props.courseUser[0], this.props.user.id);
                    let secondsLeft = moment.duration(moment(new Date(this.props.courseUser[0].currentSubjectDeadline)).diff(moment())).as('seconds');
                    let timeTaken = moment.duration(new Date() - new Date(this.props.courseUser[0].currentSubjectStart)).as('seconds');

                    let videosInCourse = 0;



                      // Days from start to deadline
                      let totalDiff = moment.duration(moment(new Date(this.props.courseUser[0].currentSubjectDeadline)).diff(moment(this.props.courseUser[0].currentSubjectStart))).as('days'); // (deadline - started) / (1000);
                      
                      // Days from start to now
                      let actualDiff = moment.duration(moment(new Date()).diff(moment(this.props.courseUser[0].currentSubjectStart))).as('days');
                      let completedVideos = this.props.us.filter(l => l.completed && l.active).length;
            
                      // How many videos must be completed per day to meet deadline:
                      let estimatedAverage =  videosInCourse / Math.ceil(totalDiff);
                      // How many videos are being completed per day on average
                      
                      let requiredPerDay = Math.ceil(estimatedAverage);
                      let actualAverage = completedVideos / Math.ceil(actualDiff);
                       
                      let estimatedDays = videosInCourse / actualAverage;
                       // avg completed = completed / (86400 * daysSinceStart) (1 day) = 2
                      // estimatedComplete = avg (2) * daysRemaining
                      
                      let estimatedSecondsToComplete;
                        if (this.props.courseUser[0].estimatedFinishDate) {
                            estimatedSecondsToComplete = moment.duration(moment(this.props.courseUser[0].estimatedFinishDate).diff(moment())).as('seconds');
                        }

                      let estimatedTimeClass = 'green';
            
                        if(secondsLeft === 0){
                            estimatedTimeClass = 'red';
                        }else if (estimatedSecondsToComplete > secondsLeft) {
                            estimatedTimeClass = 'green';
                      }else if(estimatedSecondsToComplete < secondsLeft){
                          estimatedTimeClass = 'yellow';
                      }
                      
                      let timeToTest = -1;
                      if(this.props.courseUser[0].testDate){
                          timeToTest = moment.duration(moment(this.props.courseUser[0].testDate).diff(moment())).as('seconds');
                      }

                    this.setState({setTimer: true, timeLeft: secondsLeft, timeTaken: timeTaken, estimatedTime: estimatedSecondsToComplete, estimatedTimeClass: estimatedTimeClass, timeToTest, requiredPerDay}, () => {

                        if (!this.timerId) {
                            // Initiate lecture timer
                            //this.timerId = setInterval(this.updateTimer, 1000);

                        }
                    })


                    
                }
            
            
            if(this.props.courseUser[0].testDate && !this.props.courseUser[0].completedCourse){
                let td = moment(this.props.courseUser[0].testDate);
                let today = moment(new Date());
             
                if(today.diff(td, 'days') >= 0 && this.state.canResetTestDate === false){
                    
                    this.setState({canResetTestDate: true});
                }else if(today.diff(td, 'days') < 0 && this.state.canResetTestDate === true){
                        this.setState({canResetTestDate: false});
                    
                }
            }
            
            

            if(currentSubject === null && this.props.course){
                currentSubject = this.props.courseUser[0].currentSubject;
                let subject = this.props.course.CourseSubject.filter(s => s.id === currentSubject)[0];
                if(subject){
                    if(!this.props.courseUser[0].currentSubjectDeadline && !subjectDate && subject.duration){
                        let d = moment().add(subject.duration - 1, 'days');
                        subjectDate = 'zabutocalendar_' + d.format('YYYY-MM-DD');
                    }
                }
            }

            if(studiedLastMonth === null && this.props.courseUser[0].id){
                let d = parseInt(moment(new Date()).subtract(1, 'months').format('MM'));
                let studiedDates = [];
                if(this.props.courseUser[0].studied){
                    this.props.courseUser[0].studied.map(a => {
                        let item = parseInt(moment(a.date).format('MM'));
                        if(item === d) {
                            let dayToPush = moment(a.date).format('DD');
                            if (studiedDates.indexOf(dayToPush) === -1) {

                                studiedDates.push(dayToPush);
                            }
                        }
                    });
                }

                studiedLastMonth = studiedDates.length;
                studiedLastMonth = studiedDates.length.toString() + ' days (' + Math.floor((studiedDates.length / parseInt(moment(new Date()).subtract(1, 'months').daysInMonth())) * 100) + '%)';
            }

            if(studiedTotal === null && this.props.courseUser[0].id){
                let c = moment(this.props.courseUser[0].created);
                let today = moment();

                let totalDays = today.diff(c, 'days') + 1;
                let daysStudied = [];

                if(this.props.courseUser[0].studied){
                    this.props.courseUser[0].studied.map(a => {
                        let dayToPush = moment(a.date).format('YYYY-MM-DD');
                        if (daysStudied.indexOf(dayToPush) === -1) {
                            daysStudied.push(dayToPush);
                        }
                    });
                }
                
                let stp = Math.floor((daysStudied.length / totalDays) * 100);
                if(stp === Infinity){
                    stp = 100;
                }
                if(isNaN(stp)){
                    stp = 0;
                }

                studiedTotal = daysStudied.length.toString() + ' days (' + stp + '%)';
            }

            if(studiedAverage === null){
                let c = moment(this.props.courseUser[0].created);
                let today = moment();

                let totalDays = today.diff(c, 'days');

                let timeStudied = 0;
                let studiedVsTotal;
                if(this.props.courseUser[0].studied){
                    this.props.courseUser[0].studied.map(part => {
                        timeStudied += part.time;
                    });
                
                
                    studiedVsTotal = timeStudied / this.props.courseUser[0].studied.length;
                }
                if(isNaN(studiedVsTotal)){
                    studiedVsTotal = 0;
                }

                studiedAverage = (studiedVsTotal / 60 / 60).toFixed(2).toString() + ' Hours';

            }
            
            if(this.props.courseUser[0].improvement){


                this.setState({improvement: this.props.courseUser[0].improvement, currentSubject, studiedTotal, studiedLastMonth, studiedAverage, subjectDate});
            }



            if(this.state.completionPercent === null && this.props.courseUser[0]){
                let completionPercent = 0;
                if(this.props.courseUser[0].completionPercent){
                    completionPercent = this.props.courseUser[0].completionPercent;
                }
    
                this.setState({completionPercent});
            }
        }
        
    }

    

    renderExpandedSubject = (subject) => {
        let behind = false;
        let missedDeadline = false;

        if(subject.id === this.props.courseUser[0].currentSubject &&
            moment(this.props.courseUser[0].currentSubjectDeadline).diff(moment(), 'days') < 0){
            missedDeadline = true;
        }

        return (
            <div className="panel-body">
                {behind &&
                    <div className="alert alert-warning">Hey,<br/>
                        You're going a slower pace than is required to meet your deadline. You need to complete at least <span
                            className="text-underline">{this.state.requiredPerDay} videos per day</span> to meet your goal.
                    </div>
                }

                {missedDeadline &&
                <div className="alert alert-danger">
                    <h1>Dratz! You missed the deadline! </h1>
                    <p className="sm-bottom20">Hey, {this.props.profile.name || this.props.profile.email}!</p>
                    <p className="sm-bottom20">Unfortunately, you did not meet the deadline that you set for yourself to
                        finish {subject.name}. This isn't a good sign and you have make sure that you're working hard to meet
                        them.</p>
                    <p className="sm-bottom20">Please <a href="#SetDeadLineModal" data-toggle="modal"
                                                         className="text-white text-underline"> set a new deadline</a>
                        to finish your goal!</p>
                    #YOUCANDOIT #StayFocused #gameon
                </div>
                }

                {subject.CourseChapter.map((chapter, i) => {
                if(chapter.type !== "test"){
                    return (
                        <div key={i}>
                            <h3 className="font-20 text-white">Chapter {i + 1}</h3>
                            <div className="row">
                                {chapter.ChapterVideo.map((v, vi) => {
                                    let part = this.props.courseUser[0].UserLecture.filter(l => l.active && l.completed).filter(p => p.id === v.id);
                                    let finished = false;
                                    let attentiveness, efficiency, quizPercent;
                                    let attentiveClass, quizClass;
                                    let attentivePercent;
                                    if(part.length > 0) {
                                        part = part[0];
                                        finished = true;
                                        attentiveness = 'N/A';
                                        let questions = this.props.videoQuestions.filter(q => q.chapterVideoId === v.id);
                                        if (questions.length > 0) {

                                            attentivePercent = parseInt((questions.filter(q => q.attempts === 1 && q.correct === true).length / questions.length) * 100);
                                            attentiveness = attentivePercent.toString() + '%' || '0%';
                                            attentiveClass = (attentivePercent > 50) ? 'rec-tag-green' : 'rec-tag-orange';

                                        }
                                        
                                        
                                        efficiency = (part.finish) ? parseInt((part.userTime / part.finish) * 100) || 0 : 100;
                                        let quizObject = [];
                                        if(this.props.profile){
                                            if(this.props.profile.ChapterTest){
                                            quizObject = this.props.profile.ChapterTest.filter(t => t.chapterVideoId === v.id);
                                            }
                                        }
                                        
                                        quizPercent = 'N/A';
                                        if (quizObject.length > 0) {
                                            quizPercent = quizObject[0].correctPercent.toString() + '%';
                                            quizClass = (quizObject[0].correctPercent > 50) ? 'rec-tag-green' : 'rec-tag-orange';
                                        }
                                    }



                                    return (
                                        <div className="col-xs-12" key={vi}>
                                            <div className="chapter_part_list_item">
                                                <div className="clearfix">
                                                    <p className="pull-left font-16"><i className={`zmdi ${(finished) ? 'zmdi-check-circle text-green' : 'zmdi-circle-o text-info'}`}></i> Part {vi + 1}</p>
                                                    <p className="pull-right font-16"></p>
                                                </div>
                                                <div className="chapter_part_list_item_details">
                                                    <div className="clearfix">
                                                        <div className={`rec-tag ${attentiveClass}`}>
                                                            <span>Attentiveness</span>
                                                            <span>{attentiveness}</span>
                                                        </div>
                                                        <div className={`rec-tag ${quizClass}`}>
                                                            <span>Quiz Score</span>
                                                            <span>{quizPercent}</span>
                                                        </div>
                                                        <div className="rec-tag last-rec-tag rec-tag-golden">
                                                            <span>Merits Earned</span>
                                                            <span className="badge">{part.points || 0}</span>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )
                }

                })}




            </div>
        )
    }

    renderCourses = () => {

        const {course, notifications} = this.props;
        
        let flags = [];
        if(this.props.courseUser.length > 0){
            
            
            if(this.props.flags){
                flags = JSON.parse(JSON.stringify(this.props.flags)).reverse();
            }
        }
        if(flags.length === 0 && this.state.stepsEnabled){
            flags = [
                {
                    id: 1,
                    content: "You missed the test!",
                    type: "red"
                  },
                {
                    "id" : 7,
                    "content" : "Avg. time spent per day doesn't meet subject deadline",
                    "type" : "orange"
                },
                {
                    "id" : 7,
                    "content" : "Avg. time spent per day doesn't meet subject deadline",
                    "type" : "orange",
                    "subjectId" : "5bfc848687262d79a9b5f15f"
                },
                {
                    id: 10,
                    content: "You've been absent for 3 days!",
                    type: "yellow"
                  }
            ]
        }
        
        

        return this.props.courseUser.map((cu, courseIndex) => {

            return (
                <div className="" key={courseIndex}>

                    <div className="row">
                        <div className="col-sm-8">
                            <h3 className="text-white font-16">Personalized Game Plan</h3>
                            <div className="panel-group sm-top20 subject-order" id="accordion">

                                {cu.officialTest ?
                                    cu.subjectOrder &&
                                course &&
                                cu.subjectOrder.map((si, subjectIndex) => {
                                    let subject = course.CourseSubject.filter(s => s.id === si)[0];
                                    let totalLectures = 0;
                                    let chapterIds = [];
                                    let us = this.props.us.filter(s => s.courseSubjectId === si && s.active);
                                    if(us.length > 0){
                                        us = us[0];
                                    }else{
                                        us = {};
                                    }
                                    
                                    if(subject){
                                    
                                    if(course){
                                    

                                    let percentComplete = us.completed ? 100 : us.completedPercent || 0;
                                    
                                    let cou = course.CourseSubject.filter(s => s.id === cu.currentSubject)[0];
                                    if(!cou){
                                        cou = {};
                                    }
                                    if(this.props.courseUser[0]){
                                        if(this.props.courseUser[0].stats){
                                            if(this.props.courseUser[0].stats.completion){
                                                if(this.props.courseUser[0].stats.completion.chart){
                                                    let chart = this.props.courseUser[0].stats.completion.chart[0];
                                                    if(chart.data){
                                                        let chartSubject = chart.data.filter(d => d.name === subject.name);
                                                        if(chartSubject[0]){
                                                            percentComplete = chartSubject[0].y;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    return (
                                        <div key={subjectIndex} className={`panel customPanel subjectPanel subject-panel-${subjectIndex} animated fadeInUp animationStep-${subjectIndex}`}>
                                            <div className="panel-heading" href={`#collapse${courseIndex}-${subjectIndex}`} data-toggle="collapse">
                                                <div className="row">
                                                    <div className="col-sm-4">
                                                        <div className="clearfix row">

                                                            {cu.currentSubject === subject.id || cou.type === "review" ?
                                                                <div className="panel-heading-section col-sm-4">
                                                                    <div className="subjectIcon">{subject.name[0]}</div>
                                                                </div>
                                                            :
                                                                <div className="panel-heading-section col-sm-4">
                                                                    <div className="subjectIcon">{subject.name[0]}<i className="zmdi zmdi-lock"></i> </div>
                                                                </div>
                                                            }

                                                            <div className="panel-heading-section col-sm-8" style={{width: "65%"}}>
                                                                <div className="sp-top0" style={{minWidth: "100px"}}>
                                                                    <p className="font-18 text-white">{subject.name}</p>
                                                                    <div className="progress progress-sm">
                                                                        <div className="progress-bar progress-bar-danger" style={{width: percentComplete + "%"}} role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                                                                    </div>
                                                                    <p><span className="font-12">{percentComplete}% complete</span></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-8">
                                                        <div className="clearfix">

                                                            {subject.type !== "review" &&
                                                            <div className="panel-heading-section">

                                                                <p className="sp-top10">Days Remaining</p>
                                                                <Counter
                                                                    timeClass=""
                                                                    seconds={this.state.timeLeft}
                                                                    direction="down"
                                                                    cu={cu}
                                                                    subject={subject}
                                                                />
                                                                
                                                            </div>
                                                            }
                                                            {subject.type !== "review" &&
                                                                <div className="panel-heading-section">
                                                                    <p className="sp-top10">Expected Finish Time</p>
                                                                    <Counter
                                                                        timeClass={this.state.estimatedTimeClass}
                                                                        seconds={this.state.estimatedTime}
                                                                        direction="up"
                                                                        cu={cu}
                                                                        subject={subject}
                                                                    />
                                                                </div>
                                                            }

                                                            <div className="panel-heading-section pull-right sp-top12">
                                                                {(cu.courseCompleted || cu.role === 'admin') ?
                                                                    <a href={`/video/${cu.courseId}/${subject.id}`} onClick={(e) => {
                                                                        e.preventDefault();
                                                                        if(subject.type === "review"){
                                                                            this.props.history.push('/my-tests/review');
                                                                        }else{
                                                                            this.props.history.push('/video/' + subject.courseId + '/' + subject.id);
                                                                        }
                                                                    }}
                                                                       className="btn btn-primary"><i className="zmdi zmdi-play"></i> Resume</a>
                                                                       : null
                                                                }

                                                                {!cu.courseCompleted && ((cu.currentSubjectDeadline && cu.currentSubject === subject.id) || cou.type === "review") && cu.role !== 'admin' ?
                                                                    this.state.timeLeft > 0 || cou.type === "review" ?
                                                                    <a href={`/video/${cu.courseId}/${subject.id}`} onClick={(e) => {
                                                                        e.preventDefault();
                                                                        if(subject.type === "review"){
                                                                            this.props.history.push('/my-tests/review');
                                                                        }else{
                                                                            this.props.history.push('/video/' + cu.courseId + '/' + subject.id);
                                                                        }
                                                                    }}
                                                                       className="btn btn-primary"><i className="zmdi zmdi-play"></i> Resume</a>
                                                                       :
                                                                       <a href={cu.testDate ? "#SetDeadLineModal" : "#"}
                                                                           onClick={(e) => {
                                                                                if(!cu.testDate){
                                                                                    NotificationManager.error("Please set a test date."); 
                                                                                }else{
                                                                                    this.setState({settingSubjectName: subject.name, settingSubjectId: subject.id})
                                                                                }
                                                                           }}
                                                                           data-toggle="modal" className="btn btn-primary"><i className="zmdi zmdi-calendar"></i> Set Deadline</a>
                                                                :
                                                                    !cu.courseCompleted && (cu.currentSubject === subject.id) && this.props.user.user.role === 'student' ?
                                                                    <span>
                                                                        {cu.testDate ?

                                                                        <a href={cu.testDate ? "#SetDeadLineModal" : "#"}
                                                                           onClick={(e) => {
                                                                                if(!cu.testDate){
                                                                                    NotificationManager.error("Please set a test date."); 
                                                                                }else{
                                                                                    this.setState({settingSubjectName: subject.name, settingSubjectId: subject.id})
                                                                                }
                                                                           }}
                                                                           data-toggle="modal" className="btn btn-primary"><i className="zmdi zmdi-calendar"></i> Set Deadline</a>
                                                                           :
                                                                           !cu.courseCompleted &&
                                                                           <a href="#nogo" className="btn btn-default"><i className="zmdi zmdi-lock"></i> Locked</a>
                                                                        }
                                                                         </span>
                                                                        
                                                                    :
                                                                        !cu.courseCompleted && this.props.user.user.role === 'student' && 
                                                                        <a href="#nogo" className="btn btn-default"><i className="zmdi zmdi-lock"></i> Locked</a>

                                                                }

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id={`collapse${courseIndex}-${subjectIndex}`} className="panel-collapse collapse">
                                                {cu.currentSubject === subject.id || this.props.us.filter(s => s.courseSubjectId === subject.id && s.completed).length > 0 ?
                                                    //this.renderExpandedSubject(subject)
                                                    null
                                                    :
                                                    <div className="panel-body no-padding">
                                                        <div className="alert alert-danger sm-bottom0">
                                                            <h1>Oh Snap! This subject is still locked.</h1>
                    
                                                            <p className="sm-bottom20">You can't access this subject because you're currently supposed to be working on your current subject.</p>
                                                            <p className="sm-bottom20">For you to score high, we've personalized the order in which you need to complete the content based on your diagnostic score, test dates and instructor feedback!</p>
                    
                    
                                                            <p>#followtheprocess</p>
                                                        </div>
                    
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    )
                                }}
                                })
                                : !cu.id ?
                                null 
                                :
                                <div>
                                    <p>You need to onboard for this course before accessing its content.</p>
                                    <p className="text-danger">NOTE: You will not be able to access the rest of the app until you complete onboarding.</p>
                                    <button className="btn btn-primary" onClick={e => {
                                        e.preventDefault();
                                        let profile = this.props.profile;
                                        profile.onboardingStep = 1;
                                        this.props.updateProfile(profile, this.props.user.id);
                                        this.props.history.push('/onboarding/' + this.props.courseUser[0].id);
                                    }}>Onboard</button>
                                </div>
                                }
                                

                            

                            </div>
                        </div>
                        <div className="col-sm-4">
                            <h3 className="text-white font-16">Notifications</h3>

                            <div className="panel customPanel blpanel sm-top20" style={{borderColor: "#FECEA8"}}>
                                <div className="panel-body" style={{overFlow: 'hidden'}}>
                                    {notifications ?
                                        notifications.map((n, ni) => {
                                            if(n.Profile){
                                                return (
                                                    <div className={`th-desc animated fadeInRight animationStep-${ni}`} key={ni}>
                                                        <div className="th-wrapper">
                                                            {n.Profile.image ?
                                                                <span>
                                                                    {n.Profile.image.indexOf('http') === -1 ?
                                                                        <img src={api.makeFileURL(n.Profile.image) || userImage} />
                                                                    :
                                                                        <img src={(n.Profile.image) ? n.Profile.image : userImage} />
                                                                    }
                                                                </span>
                                                                
                                                                :
                                                                <img src={(n.Profile.image) ? n.Profile.image : userImage} />
                                                            }
                                                            
                                                        </div>
                                                        <div className="th-desc-wrap">
                                                            {n.Profile.id === this.props.profile.id ?
                                                                <h3 className="text-white">Hey, you!</h3>
                                                                :
                                                                <h3 className="text-white">{n.Profile.name ? n.Profile.name : n.Profile.email}</h3>  
                                                            }
                                                            {n.Profile.id === this.props.profile.id ?
                                                                <p>{n.content}</p>
                                                            : 
                                                                <p>{n.content.replace(/You were/g, n.Profile.name + ' was').replace(/your/g, 'their')}</p>
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        })

                                    : null}

                                </div>
                                <div className="panel-footer" style={{borderTop: '1px solid #444'}}>
                                    <Link to={`/course-notifications/${this.props.courseUser[0].id}`} className="btn btn-default btn-block">SEE ALL</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        })

    }


    //Renders
    renderDashboardHeader = () => (
        <div className="bg-light lter b-b wrapper-md">
            <div className="row">
                <div className="col-sm12 col-xs-12">
                    <h1 className="m-n font-thin h3 text-black">
                        The Dashboard
                    </h1>
                    <small className="text-muted">
                        Everything Starts Here
                    </small>
                </div>
            </div>
        </div>
    );

    renderActivityPanel = () => (
        <div className="panel customPanel">
            <div className="panel-heading">
                <h3 className="panel-title text-uppercase">
                    <i className="zmdi zmdi-run"/>
                    Live Feed
                </h3>
            </div>
            <div className="panel-body sp-10">
                <div className="timeline">
                    {this.renderActivityItem()}
                </div>
            </div>
        </div>
    );

    renderActivityItem = () => (
        this.props.reminders.map((item, index) => (
            <div
                key={index}
                className="timeline-entry"
            >
                <div className="timeline-stat">
                    <div className={`timeline-icon bg-${item.status}`}>
                        <i className={`zmdi zmdi-${item.type}`}/>
                    </div>
                </div>
                <div className="timeline-label">
                    <h3>{item.title}</h3>
                    <p>{item.text} </p>
                    <p>
                        {
                            item.date
                            && <i className="zmdi zmdi-calendar"/>
                        }
                        {item.date}
                    </p>
                </div>
            </div>
        ))
    );

    renderReminders = () => (
        <div className="panel customPanel">
            <div className="panel-heading">
                <h3 className="panel-title text-uppercase">
                    <i className="zmdi zmdi-notifications-active"/>
                    Reminders
                </h3>
            </div>
            <div className="panel-body">
                <ul className="reminders">
                    {this.renderReminder()}
                </ul>
            </div>
        </div>
    );

    renderReminder = () => (
        this.props.reminders.map((item, index) => (
            <li key={index}>
                <div className={`alert alert-${item.status}`}>
                    <h3>{item.title}</h3>
                    <p className="due-date">
                        {item.date}
                    </p>
                    <p>
                        {item.text}
                    </p>
                </div>
            </li>
        ))
    );
    
    renderStudyPlan = () => {
        let lastEndDate = null;
        
        if(this.props.courseUser[0].subjectOrder){
        return this.props.courseUser[0].subjectOrder.map((so, i) => {
            
            let subject = this.props.course.CourseSubject.filter(s => s.id === so)[0];
            let dateRange = '';
            if(subject){
            if(subject.id === this.props.courseUser[0].currentSubject){
                // Current subject, use today until subject end date
                let start = moment();
                
                
                
                let subjectDateSplit = this.state.subjectDate.split('_')
                let end = moment(subjectDateSplit[subjectDateSplit.length - 1]);
                lastEndDate = end;

                dateRange = start.format('MMM DD') + ' - ' + end.format('MMM DD');
            }else if(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id).length === 0){
                
                // Not completed yet, future course
                // Use previous end date as start, and date + duration as end
                let lastEnd = moment(this.state.subjectDate.split('_')[1]);
                let courseEnd = moment(this.props.courseUser[0].testDate);
                let subjectsCompleted = this.props.us.filter(s => s.completed && s.active).length;
                let subjectsToComplete = this.props.courseUser[0].subjectOrder.length;

                let subjectsRemaining = subjectsToComplete - subjectsCompleted;
                let currentSubjectIndex = this.props.courseUser[0].subjectOrder.indexOf(this.props.courseUser[0].currentSubject);
                if(i > currentSubjectIndex){
                    // After current subject;
                    try{
                    dateRange = lastEndDate.add(1, 'days').format('MMM DD') + ' - ' + lastEndDate.add(subject.duration - 1, 'days').format('MMM DD');
                    }catch(err){

                    }

                }
            }else if(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id).length > 0){
                dateRange = moment(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id)[0].subjectStarted).format('MMM DD') + ' - ' + moment(this.props.us.filter(s => s.completed && s.courseSubjectId === subject.id)[0].completedOn).format('MMM DD')
            }

            return (
                <div className="studyPlan" key={i}>
                    <h4>{subject.name}</h4>
                    <div className="studyPlanDates">
                        <div className="row">
                            <div className="col-xs-8">
                                <p>{dateRange}</p>
                            </div>
                            <div className="col-xs-4">

                            </div>
                        </div>
                    </div>

                </div>
            )
        }})
        }
    }
    
    onExit = () => {
        this.setState({stepsEnabled: false, showAvatar: true}, () => {
            let {profile} = this.props;
            profile.tourComplete = true;
            this.props.updateProfile(profile, this.props.user.id);
        })
    }
    
    render() {

        let {chart} = this.state;
        const {course} = this.props;

        let merits = 0;
        if(!this.props.courseUser){
            return (
                <div className="loader">
                    <div className="sk-folding-cube">
                        <div className="sk-cube1 sk-cube"></div>
                        <div className="sk-cube2 sk-cube"></div>
                        <div className="sk-cube4 sk-cube"></div>
                        <div className="sk-cube3 sk-cube"></div>
                    </div>
                </div>
            )
        }
        if(this.props.courseUser[0]){
            merits = this.props.courseUser[0].points;

        }


        if(!this.props.courseUser[0]){
            return (
                <div className="loader">
                    <div className="sk-folding-cube">
                        <div className="sk-cube1 sk-cube"></div>
                        <div className="sk-cube2 sk-cube"></div>
                        <div className="sk-cube4 sk-cube"></div>
                        <div className="sk-cube3 sk-cube"></div>
                    </div>
                </div>
            )
        }

        let flags = [];
        if(this.props.courseUser.length > 0){
            if(this.props.flags){
                flags = JSON.parse(JSON.stringify(this.props.flags)).reverse();
            }
        }
        const { stepsEnabled, steps, initialStep, hintsEnabled, hints } = this.state;
        
         if(flags.length === 0 && this.state.stepsEnabled){
            flags = [
                {
                    id: 1,
                    content: "You missed the test!",
                    type: "red"
                  },
                {
                    "id" : 7,
                    "content" : "Avg. time spent per day doesn't meet subject deadline",
                    "type" : "orange"
                },
                {
                    "id" : 7,
                    "content" : "Avg. time spent per day doesn't meet subject deadline",
                    "type" : "orange",
                    "subjectId" : "5bfc848687262d79a9b5f15f"
                },
                {
                    id: 10,
                    content: "You've been absent for 3 days!",
                    type: "yellow"
                  }
            ]
        }
    
        return (
            <div id="content-container" className="content-wrapper">
            <Steps
              enabled={stepsEnabled}
              steps={steps}
              initialStep={initialStep}
              onExit={this.onExit}
            />

            <section className="content db-option-3">
                {this.props.allCourseUsers.length > 1 &&
                    <div className="nav-tabs-custom no-bg inner-tabs">
                        <ul className="nav nav-tabs">
                            {this.renderTabNew()}
                        </ul>
                    </div>
                    
                }
                <div className="row">
                    {this.state.canResetTestDate &&
                        <div className="alert alert-danger" onClick={e => this.setView('test', false)}>
                            <h1>Dratz! You missed the test! </h1>
                            <p className="sm-bottom20">Hey, {this.props.profile.name || this.props.profile.email}!</p>
                            <p className="sm-bottom20">Unfortunately, you did not meet the deadline that you set for yourself to
                                finish {this.props.course.name}. This isn't a good sign and you have make sure that you're working hard to meet
                                them.</p>
                            <p className="sm-bottom20">Please <span className="text-white text-underline"> set a new test date </span>
                                to finish your goal!</p>
                            #YOUCANDOIT #StayFocused #gameon<br /><br />
                            <div className="text-right">
                                <button className="btn btn-white">Understood</button>
                            </div>
                        </div>
                        }
                        
                        {this.props.courseUser[0].UserLecture ? 
                        this.state.estimatedTime > this.state.timeLeft  && !this.props.courseUser[0].understoodSlowness && this.props.courseUser[0].UserLecture.filter(l => l.active && l.completed).length > 0 &&
                            <div className="alert alert-warning">Hey, {this.props.profile.name || this.props.profile.email}<br/>
                                You're going a slower pace than is required to meet your deadline. You need to complete at least <span
                                    className="text-underline">{this.state.requiredPerDay} videos per day</span> to meet your goal.<br /><br />
                                    <div className="text-right">
                                    <button onClick={e => {
                                        e.preventDefault();
                                        let c = this.props.courseUser[0];
                                        c.understoodSlowness = true;
                                        this.props.updateCourseUser(c, c.profileId, this.props.user.id);
                                    }} className="btn btn-white">Understood</button>
                                    </div>
                            </div>
                            : null
                        }
                    <div className="col-sm-8">
                        <h3 className="text-white font-16">Mission Control</h3>
                        <div className="rounded-views mission-control">
                            <div className="clearfix">

                                <div className="tiles-80">
                                    <div className="tile-wrapper">
                                        <div>
                                            <div className="panel-body no-padding lighter-dark" style={{border: "2px solid #565058", background: "#3c3840 !important"}}>
                                                <div className="sp-20 hidden">
                                                    <div className="row">
                                                        <div className="col-sm-5">
                                                            <a href="#nogo" className="btn btn-filter btn-default">Class Average</a>
                                                            <a href="#nogo" className="btn btn-filter btn-default active-btn-filter">Subject Performance</a>
                                                        </div>
                                                        <div className="col-sm-7">
                                                            <div className="text-right">
                                                                <a href="#nogo" className="btn btn-filter btn-default">12 Months</a>
                                                                <a href="#nogo" className="btn btn-filter btn-default active-btn-filter">6 Months</a>
                                                                <a href="#nogo" className="btn btn-filter btn-default">3 Months</a>
                                                                <a href="#nogo" className="btn btn-filter btn-default">1 Months</a>
                                                                <a href="#nogo" className="btn btn-filter btn-default">15 Days</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {this.state.viewLoaded &&
                                                <div id="AvgScoreWrapper"
                                                     style={{minWidth: "310px", height: "352px", margin: "0 auto", paddingTop: (this.state.view === 'test') ? 0 : '50px'}}>

                                                    {(this.state.view === 'attendance' || this.state.view === 'test') ?
                                                        <div>
                                                            {this.state.view === 'test' ?
                                                                <div className="deadline_calendar no-margin">
                                                                <div className="calendar_1">
                                                                    <div id="test_calendar"/>
                                                                </div>
                                                                </div>
                                                                :
                                                                (this.state.attendanceType === 'calendar') ?

                                                                <div>
                                                                    <div className="deadline_calendar">
                                                                    <div className="deadline_calendar attendance_calendar">
                                                                        <div className="calendar_3">
                                                                            <div className="btn btn-group toggleButtons toggle_attendance_calendar_graph_btns">
                                                                                <div className="" data-toggle="buttons">
                                                                                    <label className={`btn btn-default ${this.state.attendanceType === 'graph' ? 'active' : ''}`}
                                                                                           onClick={(e) => {
                                                                                               this.setState({attendanceType: 'graph', view: 'attendance', viewLoaded: false})
                                                                                           }}
                                                                                    >
                                                                                        
                                                                                        Graph</label>
                                                                                    <label
                                                                                        className={`btn btn-default ${this.state.attendanceType === 'calendar' ? 'active' : ''}`}
                                                                                        onClick={(e) => {
                                                                                                this.setState({attendanceType: 'calendar', view: 'attendance', viewLoaded: false})
                                                                                            }}
                                                                                        >
                                                                                       
                                                                                        Calendar</label>
                                                                                </div>
                                                                            </div>
                                                                            <div id="test_calendar" className="attendance-calendar">
                                                                            </div>
                                                                        </div>
                                                                        <div className="attendance_details">
                                                                            <div className="attendance-details-row attendance-studied"><h5>
                                                                                Studied Last Month</h5><p>{this.state.studiedLastMonth || 0}</p></div>
                                                                            <div className="attendance-details-row attendance-overall"><h5>
                                                                                Overall Attendance</h5><p>
                                                                                {this.state.studiedTotal || ''}
                                                                            </p></div>
                                                                            <div className="attendance-details-row attendance-average"><h5>Avg
                                                                                Study Per Day</h5><p>{this.state.studiedAverage}</p></div>
                                                                        </div>
                                                                    </div>
                                                                    </div>
                                                                </div>

                                                                    :
                                                                    <div>
                                                                        <div className="">
                                                                            <div className="">
                                                                                <div className="btn btn-group toggleButtons toggle_attendance_calendar_graph_btns">
                                                                                <div className="" data-toggle="buttons">
                                                                                    <label className={`btn btn-default ${this.state.attendanceType === 'graph' ? 'active' : ''}`}
                                                                                           onClick={(e) => {
                                                                                               this.setState({attendanceType: 'graph', view: 'attendance', viewLoaded: false})
                                                                                           }}
                                                                                    >
                                                                                        
                                                                                        Graph</label>
                                                                                    <label
                                                                                        className={`btn btn-default ${this.state.attendanceType === 'calendar' ? 'active' : ''}`}
                                                                                        onClick={(e) => {
                                                                                                this.setState({attendanceType: 'calendar', view: 'attendance', viewLoaded: false})
                                                                                            }}
                                                                                        >
                                                                                       
                                                                                        Calendar</label>
                                                                                </div>
                                                                            </div>
                                                                                <ReactHighcharts
                                                                                    config={this.renderConfigHighchart(chart)}
                                                                                    isPureConfig={true}
                                                                                    neverReflow={true}
                                                                                    ref="chart"
                                                                                />
                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                            }
                                                        </div>

                                                        :
                                                        <div>
                                                            {this.state.view === 'quiz' &&
                                                                <div className="row">
                                                                    <div className="col-md-6"></div>
                                                                    <div className="col-md-6">
                                                                        <div className="row">
                                                                            <div className="menu-wrapper-inside-graph">
                                                                                <select className="form-control"
                                                                                        value={this.state.currentSubject}
                                                                                        onChange={(e) => {
                                                                                            let {currentSubject} = this.state;
                                                                                            currentSubject = e.target.value;
                                                                                            this.setState({currentSubject}, () => {
                                                                                                this.buildChart('quiz');
                                                                                            });
                                                                                        }}>
                                                                                    <option value="all">All Subject Data</option>

                                                                                    {this.props.course.CourseSubject.map((s, i) => {
                                                                                        return (
                                                                                            <option value={s.id} key={i}>{s.name}</option>
                                                                                        )
                                                                                    })}
                                                                                </select>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            }
                                                            {chart &&
                                                                chart[0] ?
                                                                chart[0].data.length > 0 ?
                                                                    <ReactHighcharts
                                                                        config={this.renderConfigHighchart(chart)}
                                                                        ref="chart"
                                                                        isPureConfig={false}
                                                                        neverReflow={true}
                                                                        
                                                                    />
                                                                : <div style={{
                                                                    fontWeight: 'bold',
                                                                    fontSize: '15px',
                                                                    color: '#fff',
                                                                    textAlign:'center',
                                                                }} className='text-center nodataGraph'><img src={loadingIcon} />We can't show you any results yet! <br />Finish the first chapter, and come back to have a look.</div>
                                                            :
                                                            <div style={{
                fontWeight: 'bold',
                fontSize: '15px',
                color: '#fff',
                textAlign:'center',
            }} className='text-center nodataGraph'><img src={loadingIcon} />We can't show you any results yet! <br />Finish the first chapter, and come back to have a look.</div>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                                }


                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tile-20">
                                    <div className="tile-wrapper merits-tile">
                                        <div className="tile-dark">

                                            <div className="tile-content">
                                                <a href="#nogo"
                                                    className="merit-tile-light-bg"
                                                    style={{borderTopRightRadius: 5, overflow: 'hidden', backgroundColor: '#474249 !important'}}
                                                  >
                                                    <img src={trophy} style={{width: "50px", position: "relative", top: "4px"}} />
                                                        <h2>{this.props.courseUser.length > 0 ? this.props.courseUser[0].points : 0}</h2>
                                                        <span>Merits</span>
                                                </a>
                                            </div>



                                        </div>
                                    </div>
                                    <div className="tile-wrapper completion-tile">
                                        <div className="">
                                            <div className="tile-content">
                                                <a
                                                    href="#nogo"
                                                    style={{paddingTop: "20px", paddingBottom: "73px"}}
                                                    className={
                                                        (this.state.view === 'completion') ? 'tile-active' : ''
                                                    }
                                                    onClick={(e) => this.setView('completion', false)}
                                                >
                                                    <PieChart
                                                        style={{width: 100, margin: '0 auto'}}
                                                        data={[
                                                            {value: 100, color: '#555'},
                                                            {value: (this.state.completionPercent) ? this.state.completionPercent : 0, color: '#e33339'}
                                                        ]}
                                                        totalValue={100}
                                                        startAngle={-90}
                                                        lineWidth={10}
                                                        rounded={true}
                                                    />
                                                    <p className="diagnostic-pie-chart-counter chart-tile">{
                                                        this.props.courseUser[0] ?
                                                            this.props.courseUser[0].completionPercent ?
                                                                this.props.courseUser[0].completionPercent
                                                            : 0
                                                        : 0
                                                        }%</p>
                                                    <span>Completion</span>
                                                </a>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="clearfix">

                                <div className="tile-20">
                                    <div className="tile-wrapper tile-dark attendance-tile">
                                        <div className="tile-content">
                                            {this.state.improvement.attendance !== null &&
                                                <span>
                                                    {this.state.improvement.attendance.type === 'up' ?
                                                        <div className="tile-status text-green">
                                                            <i className="fa fa-caret-up"></i>
                                                            &nbsp;{this.state.improvement.attendance.value}%
                                                        </div>
                                                        :
                                                        <div className="tile-status text-red">
                                                            <i className="fa fa-caret-down"></i>
                                                            &nbsp;{this.state.improvement.attendance.value}%
                                                        </div>

                                                    }
                                                </span>
                                            }
                                            <a
                                                href="#nogo"
                                                style={{borderBottomLeftRadius: 5}}
                                                className={
                                                        (this.state.view === 'attendance') ? 'tile-active' : ''
                                                    }
                                                onClick={(e) => this.setView('attendance', false)}
                                            >
                                                <i className="far fa-calendar-check" style={{fontSize: "80px !important", top: "10px", position: "relative"}} />
                                                <span>Attendance</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="tile-20">
                                    <div className="tile-wrapper attentiveness-tile">
                                        <div className="tile-content">
                                            {this.state.improvement.attentiveness !== null &&
                                            <span>
                                                    {this.state.improvement.attentiveness.type === 'up' ?
                                                        <div className="tile-status text-green">
                                                            <i className="fa fa-caret-up"></i>
                                                            &nbsp;{this.state.improvement.attentiveness.value}%
                                                        </div>
                                                        :

                                                        (this.state.improvement.attentiveness.type === 'none') ?
                                                            <div className="tile-status text-red">
                                                                &nbsp;{this.state.improvement.attentiveness.value}%
                                                            </div>
                                                            :
                                                        <div className="tile-status text-red">
                                                            <i className="fa fa-caret-down"></i>
                                                            &nbsp;{this.state.improvement.attentiveness.value}%
                                                        </div>

                                                    }
                                                </span>
                                            }
                                            <a
                                                href="#nogo"
                                                className={
                                                        (this.state.view === 'attentiveness') ? 'tile-active' : ''
                                                    }
                                                style={{paddingTop: "20px", paddingBottom: "73px"}}
                                                onClick={(e) => this.setView('attentiveness', false)}
                                            >
                                                <PieChart
                                                    style={{width: 100, margin: '0 auto'}}
                                                    data={[
                                                        {value: 100, color: '#555'},
                                                        {value: this.state.attentivePercent, color: '#e33339'}
                                                    ]}
                                                    startAngle={-90}
                                                    totalValue={100}
                                                    lineWidth={10}
                                                    rounded={true}
                                                />
                                                <p className="diagnostic-pie-chart-counter chart-tile">{this.state.attentivePercent > 100 ? 100 : Math.ceil(this.state.attentivePercent)}%</p>

                                                <span>Attentiveness</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="tile-20">
                                    <div className="tile-wrapper tile-dark efficiency-tile">
                                        <div className="tile-content">
                                            {this.state.improvement.efficiency !== null &&
                                            <span>
                                                    {this.state.improvement.efficiency.type === 'up' ?
                                                        <div className="tile-status text-green">
                                                            <i className="fa fa-caret-up"></i>
                                                            &nbsp;{this.state.improvement.efficiency.value}%
                                                        </div>
                                                        :
                                                        (this.state.improvement.efficiency.type === 'none') ?
                                                            <div className="tile-status text-red">

                                                                &nbsp;{this.state.improvement.efficiency.value}%
                                                            </div>
                                                            :
                                                        <div className="tile-status text-red">
                                                            <i className="fa fa-caret-down"></i>
                                                            &nbsp;{this.state.improvement.efficiency.value}%
                                                        </div>

                                                    }
                                                </span>
                                            }
                                            <a
                                                href="#nogo"
                                                className={
                                                        (this.state.view === 'efficiency') ? 'tile-active' : ''
                                                    }
                                                onClick={(e) => this.setView('efficiency', false)}
                                            >
                                                <i className="ion ion-speedometer" />
                                                <span>Efficiency</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="tile-20">
                                    <div className="tile-wrapper quiz-tile">
                                        <div className="tile-content quizAvg">
                                            {this.state.improvement.quiz !== null &&
                                            <span>
                                                    {this.state.improvement.quiz.type === 'up' ?
                                                        <div className="tile-status text-green">
                                                            <i className="fa fa-caret-up"></i>
                                                            &nbsp;{this.state.improvement.quiz.value}%
                                                        </div>
                                                        :
                                                        (this.state.improvement.quiz.type === 'none') ?
                                                            <div className="tile-status text-red">
                                                                &nbsp;{this.state.improvement.quiz.value}%
                                                            </div>
                                                            :
                                                            <div className="tile-status text-red">
                                                                <i className="fa fa-caret-down"></i>
                                                                &nbsp;{this.state.improvement.quiz.value}%
                                                            </div>

                                                    }
                                                </span>
                                            }
                                            <a
                                                href="#nogo"
                                                style={{paddingTop: "40px"}}
                                                className={
                                                        (this.state.view === 'quiz') ? 'tile-active' : ''
                                                    }
                                                onClick={(e) => this.setView('quiz', false)}
                                            >
                                                <i className="fa fa-signal" style={{fontSize: "70px"}} />
                                                <span>Quiz Average</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="tile-20">
                                    <div className="tile-wrapper tile-dark test-tile">
                                        <div className={`tile-content ${this.props.courseUser[0].testDate ? 'date-has-been-selected' : ''}`} id="date_tile">
                                            {this.props.courseUser[0].testDate ?
                                            
                                                <a href="#nogo"  style={{borderBottomRightRadius: 5}}
                                                    onClick={(e) => this.setView('test', false)}>
                                                    <Counter
                                                        fullDays={true}
                                                        timeClass=""
                                                        seconds={this.state.timeToTest}
                                                        direction="down"
                                                        cu={this.props.courseUser[0]}
                                                        subject={null}
                                                    />
                                                    
                                                    <span className="">Time to test</span>
                                                </a>
                                    
                                            :
                                                <a
                                                    href="#nogo"
                                                    style={{borderBottomRightRadius: 5}}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                    
                                                        this.setState({view: 'test', viewLoaded: false});
                                                    }}
                                                >
                                                    <i className="icon ion-ios-alarm selectTestDate" style={{fontSize: "80px"}} />
                                                    <div id="selected_test_date_timer">00:00:00</div>
    
                                                    <span className="selectTestDate">
                                                        {this.props.courseUser[0].testDate ?
                                                            <span>
                                                                {moment(this.props.courseUser[0].testDate).add(1, 'day').format('MMM DD YYYY')}
                                                                </span>
                                                            :
                                                            <span>Select test date</span>
                                                        }
                                                    </span>
                                                </a>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <h3 className="text-white font-16"> Red Flags {this.props.flags && <span className="font-12">({this.props.flags.length})</span>} <i className="zmdi zmdi-info" data-trigger="hover" data-toggle="popover" data-html="true" data-content="Red Flags are notifications that you receive when you are following the process and adhering to our community standards.<br /><br />

You are guaranteed a score as long as you are following you adhere to set deadlines, finish your work on time, put in the work required, and fix your mistakes as you go.<br /><br />

99point9 reserves the right to  void a students score guarantee, as outlined in the student contract, if the student does fails to meet these standards. " data-original-title="" title=""></i></h3>
                        <div className="panel customPanel blpanel flags-panel" style={{borderColor: "#FF847C"}}>
                            <div className="panel-body" style={{height: "484px", overflowY: "auto"}} >
                                {flags.length > 0 ?
                                    flags.filter((n, i) => i < 6).map((f, fi) => {
                                        return (
                                            <div className="th-desc" key={fi}>
                                                <div
                                                    className="th-wrapper"
                                                    data-toggle="popover"
                                                    data-trigger="hover"
                                                    title=""
                                                    data-content="And here's some amazing content. It's very engaging. Right?"
                                                    data-original-title="Popover title">

                                                    {f.type === 'red' &&
                                                        <div className="flagIcon  ">
                                                            <i className="zmdi zmdi-flag"></i>
                                                        </div>
                                                    }
                                                    {f.type === 'yellow' &&
                                                        <div className="flagIcon  yellow-flag">
                                                            <i className="zmdi zmdi-alert-triangle"></i>

                                                        </div>
                                                    }
                                                    
                                                    {f.type === 'orange' &&
                                                        <div className="flagIcon orange-flag">
                                                            <i className="zmdi zmdi-flag"></i>
                                                        </div>
                                                    }
                                                </div>
                                                <div className="th-desc-wrap">
                                                    <h3>{f.content}</h3>
                                                </div>
                                            </div>
                                        )
                                    })
                                    :
                                    <div className="empty-alerts text-green">
                                        <i className="zmdi zmdi-check zmdi-lg" />
                                        <h4>Nothing to worry about!</h4>
                                    </div>
                                }

                            </div>
                            <div className="panel-footer" style={{borderTop: '1px solid #444'}}>
                                <Link to={`/red-flags/${this.props.courseUser[0].id}`} className="btn btn-default btn-block">SEE ALL</Link>
                            </div>
                        </div>

                    </div>
                </div>

                {this.props.courseUser.length > 0 &&
                    this.renderCourses()
                }
            </section>

                {this.state.confirmTestDateModal &&
                    <ConfirmationModal
                        title="Confirm Official Test Date!"
                        text="Are you sure you want to choose this date as your official test date?"
                        cancel={() => this.setState({confirmTestDateModal: false})}
                        confirm={() => this.setCourseUserTestDate()}
                    />
                }

                {this.state.confirmSubjectDateModal &&
                    <ConfirmationModal
                        title="Confirm Subject End Date!"
                        z={999999}
                        text="Are you sure you want to choose this date as your expected finish date?"
                        cancel={() => this.setState({confirmSubjectDateModal: false})}
                        confirm={() => this.setCourseUserSubjectDate()}
                    />
                }

                {this.state.showAvatar &&
                    <AvatarModalContainer dismiss={() => this.setState({showAvatar: false})} />
                }

                

                {this.props.courseUser[0].testDate ?
                    course ? 
                        this.props.us ?
                        
                            <DeadlineModal
                                courseUser={this.props.courseUser}
                                course={course}
                                us={this.props.us}
                                onSelect={(date) => this.setState({confirmSubjectDateModal: true, subjectDate: date})}
                                timeLeft={this.state.timeLeft}    
                            />
                        : null
                        : null
                : null}
            </div>
        )
    }

    renderOld() {
        return (
            <div
                id="content-container"
                className="content-wrapper"
            >
                {this.renderDashboardHeader()}
                <section className="content">
                    <div className="row">
                        <CourseStatusContainer />
                        <div className="col-sm-4">
                            {this.renderActivityPanel()}
                            {this.renderReminders()}
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

Dashboard.propTypes = {
    user: PropTypes.shape({
        user: PropTypes.shape({
            email: PropTypes.string.isRequired,
            id: PropTypes.string.isRequired
        })
    }),
    courseUser: PropTypes.arrayOf(PropTypes.shape({
     id: PropTypes.string.isRequired
   })).isRequired
};

export default Dashboard;


// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardUser/Dashboard.js